<template>
  <div :class="[
    'chat-wrap',
    // 样式为 1：新版 UI；样式为 0 或未配置：老版 UI
    agentConfig && agentConfig.style && agentConfig.style.style === 1
      ? (stepList[curStep] && stepList[curStep].type !== 'aiGenerate'
          ? 'chat-newui chat-temp1'
          : 'chat-newui chat-temp2')
      : 'chat-oldui',
    // 仅在新版 UI 下且存在 aiModelId 时添加弹窗样式
    agentConfig && agentConfig.style && agentConfig.style.style === 1 && customDeskInfo.aiModelId ? 'chat-pop' : '',
    isShowHistory ? 'chat-wrap-history' : ''
  ]">
    <template v-if="agentConfig && agentConfig.style && agentConfig.style.style === 1">
      <div class="btn-close-pop" v-if="customDeskInfo.aiModelId">
        <el-icon style="font-size: 20px;" @click="closePop"><Close /></el-icon>
      </div>
      <div class="ai-temp1" :class="{ scaled: isScaled }">
        <h6>欢迎使用AI内容分析</h6>
        <div class="pop">
          <img src="https://bigdata.topeti.com/PCRepository/mainPlatform/chat-pp.png" />
          <p>{{ agentConfig && agentConfig.style && agentConfig.style.style === 1 ? agentConfig.style.text1 : '' }}</p>
        </div>
        <img class="girl" :src="agentConfig && agentConfig.style && agentConfig.style.avatarId ? 'https://bigdata.topeti.com/PCRepository/mainPlatform/chat/l-' + agentConfig.style.avatarId + '.png' : $url + '/confiles/' + agentConfig.style.fullBodyImage" />
      </div>
      <div :class="[customDeskInfo.aiModelId ? 'ai-temp3' : 'ai-temp2']">
        <img class="girl" :src="agentConfig && agentConfig.style && agentConfig.style.avatarId ? 'https://bigdata.topeti.com/PCRepository/mainPlatform/chat/s-' + agentConfig.style.avatarId + '.png' : $url + '/confiles/' + agentConfig.style.halfBodyImage" />
        <p>{{agentConfig.style.text2}}</p>
        <swipeStep v-if="currentSkill && currentSkill.value !== 'multiModal'" class="step" :steps="stepList" :curStep="curStep" :agentConfig="agentConfig" @changeStep="changeStep" />
      </div>
    </template>
    
    <div class="chat-main">
      <history v-if="isShowHistory" ref="historyRef" :aiModelId="Number(aiModelId)" @changeHistory="changeHistory" @addRecord="addRecord" />
      <div class="chat-content">
        <div class="header">
          <h4>{{appName}}</h4>
          <swipeStep v-if="currentSkill && currentSkill.value !== 'multiModal'" class="step" :steps="stepList" :curStep="curStep" :agentConfig="agentConfig" @changeStep="changeStep" />
        </div>
        <div class="cont" v-if="stepList.length > 0" v-loading="pageLoading">
          <el-scrollbar class="el-menu-scrollbar__wrap inputBoxArea" v-if="stepList[curStep].type === 'dataForm'">
            <el-form
              v-show="stepList[curStep].show"
              :model="ruleForm"
              ref="ruleForm"
              :label-position="'top'"
              class="form-class"
              @submit.prevent
            >
              <widget-one-layer
                v-model:ruleListChild="ruleList"
                v-model:approvalId="approvalId"
                :formdata="formdata"
                :modifyId="''"
                othersObj="{}"
                :layout="formLayout"
                :associationVisible="associationVisible"
                @submit="submitForm"
                ref="widgetOneLayerRef"
              ></widget-one-layer>
            </el-form>
          </el-scrollbar>
          <div class="table-wrap" v-else-if="stepList[curStep].type === 'dataTable'">
            <div style="height: 100%;" v-show="stepList[curStep].show" v-loading="!stepList[curStep].show">
              <dataTable v-if="stepList[curStep].dataInfo.insideInfo.datatype === 2" :approvalReportId="stepList[curStep].dataInfo.insideInfo.appid" 
              :aitableHide="!stepList[curStep].show" 
              :stepConfig="stepList[curStep]" 
              :customDeskInfo="customDeskInfo"/>
              <template v-else-if="isComp && showTable">
                <component :is="isComp" :customDeskInfo="customDeskFormInfo" />
              </template>
            </div>
          </div>
          <div class="table-wrap" v-else-if="stepList[curStep].type === 'dataWrite'">
            <!-- 写入成功 -->
          </div>
          <template v-else-if="stepList[curStep].type === 'dataGenerate'">
            <!-- 数据查询 -->
            <div class="data-generate">
              <aiChatContent :stepConfig="stepConfig" :isShowHistory="isHistory" :aiModelId="aiModelId" openType="dataGenerate" />
            </div>
          </template>
          <!-- 文件查询 -->
          <template v-else-if="stepList[curStep].type === 'fileGenerate'">
            <aiChatContent :stepConfig="stepConfig" :isShowHistory="isHistory" :aiModelId="aiModelId" :defaultQuestion="defaultQuestion" openType="fileGenerate" />
          </template>
          <!-- 内容创作 -->
          <template v-else-if="stepList[curStep].type === 'contentGenerate'">
            <aiChatContent :stepConfig="stepConfig" :isShowHistory="isHistory" :aiModelId="aiModelId" :defaultQuestion="defaultQuestion" openType="contentGenerate" />
          </template>
          
          <div class="robot-wrap" v-else>
            <div class="robot-start" v-if="thinking && robotAnimate">
              <img :src="`https://bigdata.topeti.com/PCRepository/mainPlatform/robot-img.gif?t=${Date.now()}`" alt="" />
              <p>正在努力分析中...</p>
            </div>
            <div
              v-show="!robotAnimate"
              id="chat-msg"
              :class="layout.dialogText && layout.dialogText !== '' ? 'robot-result' : 'robot-result robot-default'"
            >
              <div class="scroll-btn" v-if="showScrollButtons">
                <div class="btn-up" v-show="showUpButton" @click="scrollToPosition('up')">
                  <el-icon><ArrowUp /></el-icon>
                </div>
                <div class="btn-down" v-show="showDownButton" @click="scrollToPosition('down')">
                  <el-icon><ArrowDown /></el-icon>
                </div>
              </div>
              <el-scrollbar class="el-menu-scrollbar__wrap" style="height:100%;" ref="scrollArea"
                      @scroll="handleScroll">
                <div
                  class="block"
                  v-for="(session, index) in sessions"
                  :key="index"
                >
                  <div v-if="session.role === 'user' && (otherData.showQuestion || index !== firstUserIndex)" class="user">
                    <img class="avatar" :src="agentConfig && agentConfig.style && agentConfig.style.style === 1 ? agentConfig.style.avatarId ? 'https://bigdata.topeti.com/PCRepository/mainPlatform/chat/s-' + agentConfig.style.avatarId + '.png' : $url + '/confiles/' + agentConfig.style.halfBodyImage : robotImg && robotImg.includes('bigdata') ? robotImg : $apiurl + robotImg" />
                    <div class="msg" v-html="formatContent(session.content)"></div>
                  </div>
                  <div v-if="session.role === 'assistant'" class="robot">
                    <img class="avatar" src="https://bigdata.topeti.com/PCRepository/mainPlatform/cottonbotLogo.png">
                    <div class="box">
                      <div class="ai-think" v-if="session.role === 'assistant' && session.type !== 'image' && session.type !== 'video'" @click="toggleThinking"><i
                        class="WSiconfont WSicon-icon_interests" />{{ isReasonModel ? (thinking ? '思考中' : '已思考(用时 ' + session.time + ' 秒)') : '已思考' }}<i class="iconfont icon-xiangshang" /></div>
                      <div class="app-check-list" v-if="session.appCheckResult && session.appCheckResult.length > 0">
                        <div class="app-check-tips">根据您的描述，为你找到以下结果，点击按钮即可打开</div>
                        <buttonComp
                          v-for="(item, index) in session.appCheckResult"
                          @openAppInitiate="openAppInitiate"
                          @open-appDialog="openAppDialog"
                          @custom-scene="customScene"
                          :info="item"
                          :isAiCheck="true"
                          :key="index" />
                      </div>
                      <div class="ai-loading" v-if="session.content === '' && session.type !== 'image' && session.type !== 'video'"></div>
                      <template v-else>
                        <div class="img-block" v-if="session.type === 'image'">
                          <div class="img-wrap" v-for="(item, index) in (session.content || [null])" :key="index">
                            <div class="img-loading-mask" v-if="!session.content">
                              <div class="img-spinner"></div>
                            </div>
                            <template v-else>
                              <img :src="item.url" />
                              <div class="img-actions">
                                <div class="img-btn" @click="reGenImage(its, valueDoubaoIS)">
                                  <i class="iconfont icon-zhongxinjiazai" />
                                  再次生图
                                </div>
                                <span>|</span>
                                <div class="img-btn" @click="downloadImage(session.content)" :disabled="!session.content">
                                  <i class="iconfont icon-xiazai1" />
                                  下载
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                        <div class="img-block" v-else-if="session.type === 'video'">
                          <div class="img-wrap">
                            <div class="img-loading-mask" v-if="!session.content">
                              <div class="img-spinner"></div>
                            </div>
                            <template v-else>
                              <video
                                :src="session.content"
                                controls
                                style="width:100%;max-width:480px;display:block;"
                              ></video>
                              <div class="img-actions">
                                <div class="img-btn" @click="openVideoDialog(session.content)">
                                  <i class="iconfont icon-fangda5" />
                                  放大
                                </div>
                                <span>|</span>
                                <div class="img-btn" @click="downloadVideo(session.content)" :disabled="!session.content">
                                  <i class="iconfont icon-xiazai1" />
                                  下载
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                        <markdownTypewriter v-else-if="valueModel === 'yiyan'" :markdown="session.content" 
                        @finishAnswer="finishAnswer" />
                        <v-md-editor
                          v-else
                          v-model="session.content"
                          mode="preview"
                          :preview-options="previewOptions"
                        ></v-md-editor>
                      </template>
                      <div class="copy" v-if="session.role === 'assistant' && answerOver">
                        <div class="ai-button-left">
                          <el-tooltip content="复制结果" placement="top" effect="dark">
                              <i class="WSiconfont WSicon-fuzhiicon" @click="copy(session.content)" />
                          </el-tooltip>
                        </div>
                        <el-button v-if="showContinueBtn" @click="continueAnswer" class="ai-button-right">继续生成</el-button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="thinking && sessions.length > 0 && sessions[sessions.length - 1].role === 'user'" class="block">
                  <div class="robot">
                    <img class="avatar" style="opacity:0;" src="https://bigdata.topeti.com/PCRepository/mainPlatform/cottonbotLogo.png">
                    <div class="box">
                      <div class="ai-dots-loading">
                        <span></span><span></span><span></span>
                      </div>
                    </div>
                  </div>
                </div>
              </el-scrollbar>
            </div>
            <div class="drag-area" ref="dragArea" v-if="showDrag">
              <div class="tools-container">
                <div class="drag-left-content">
                  <div :key="comps.i" v-for="comps in leftLayout(layout.info)">
                    <button-comp
                      v-if="comps.type === 'button'"
                      :info="comps"
                      @getResultMsg="getResultMsg"
                      @goAnswer="goAnswer"
                      @openAppInitiate="openAppInitiate"
                      @custom-scene="customScene"
                    ></button-comp>
                  </div>
                </div>
                <div class="drag-right-content">
                  <div :key="comps.i" v-for="comps in rightLayout(layout.info)">
                    <button-comp
                      v-if="comps.type === 'button'"
                      :info="comps"
                      @getResultMsg="getResultMsg"
                      @goAnswer="goAnswer"
                      @openAppInitiate="openAppInitiate"
                      @custom-scene="customScene"
                    ></button-comp>
                  </div>
                </div>
              </div>
            </div>
            <div :class="['sendinput', chatBoxFloat ? 'sendinput-float' : '']" v-if="layout.dialogText && layout.dialogText !== '' && !robotAnimate">
              <div class="input-area" :class="{ 'input-border': queryMessage }">
                <textarea v-model="queryMessage" ref="editor" v-focus :placeholder="layout.dialogText" @input="adjustTextareaHeight" @keydown.enter="e => { if(!e.shiftKey) { e.preventDefault(); communicate(); } }"></textarea>
                <div class="input-tools">
                  <div class="fl">
                    <el-select v-if="valueModel === 'doubao-image'" v-model="valueDoubaoIS" placeholder="请选择宽高比" size="small" style="width:60px;">
                        <el-option v-for="item in doubanConfig.image.size" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                    <template v-if="valueModel === 'doubao-video'">
                        <el-select v-model="valueDoubaoVR" placeholder="请选择宽高比" size="small" style="width:60px;">
                            <el-option v-for="item in doubanConfig.video.ratio" :key="item" :label="item"
                                :value="item"></el-option>
                        </el-select>
                        <el-select v-model="valueDoubaoVD" placeholder="请选择时长" size="small" style="width:60px;">
                            <el-option v-for="item in doubanConfig.video.duration" :key="item" :label="item + '秒'"
                                :value="item"></el-option>
                        </el-select>
                    </template>
                    <aiChatBtn @confirmOk="confirmOk" v-model:voiceConfig="voiceConfig" @stopPlay="stopPlay"  />
                    <template v-if="currentSkill && currentSkill.value === 'multiModal'">
                        <el-select v-model="valueType" style="width:88px;margin-left:5px;" size="small" @change="val => onMultiModalChange(val, currentSkill.list)">
                            <el-option v-for="(item, index) in currentSkill.list" :key="index" :label="item.name"
                                :value="item.type"></el-option>
                        </el-select>
                    </template>
                    <span
                        class="tool-item"
                        :class="{ active: onlineSwitch }"
                        v-if="onlineSearch"
                        @click="openOnline"
                    >
                        <i class="WSiconfont WSicon-lianwang" />
                        联网搜索
                    </span>
                    <el-select v-if="modelList.length > 1" v-model="valueModel" placeholder="请选择模型" size="small">
                        <template #prefix>
                            <i class="WSiconfont WSicon-moxing" />
                        </template>
                        <el-option v-for="item in modelList" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                    <span class="tool-item" v-if="sessions.length > 0" @click="clearHistory">清空记录</span>
                  </div>
                  <div class="fr">
                    <template v-if="!queryMessage && answerOver">
                      <el-tooltip content="请输入你的问题" placement="top" effect="dark">
                        <span class="btn-submit">
                          <el-icon><Top /></el-icon>
                        </span>
                      </el-tooltip>
                    </template>
                    <template v-else-if="queryMessage && answerOver">
                      <span class="btn-submit btn-submit-high" @click="communicate($event)">
                        <el-icon><Top /></el-icon>
                      </span>
                    </template>
                    <template v-else>
                      <span class="btn-submit btn-submit-high" @click="stopThinking">
                        <i class="WSiconfont WSicon-a-Rectangle346240893"></i>
                      </span>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>        
          <div class="submit" v-if="!showDrag">
            <template v-if="!startRobot">
              <el-button 
                v-if="showPrevButton && prevButton" 
                @click="prevStep">上一步</el-button>
              <el-button 
                v-if="showNextButton" 
                type="primary" 
                @click="nextStep">下一步</el-button>
              <el-button 
                v-if="showStartButton" 
                type="primary" 
                @click="nextStep">开始生成</el-button>
            </template>
            <el-button class="btn-stop" v-else-if="startRobot && thinking" @click="stopRobot"><i class="iconfont icon-tingzhi1"></i>停止</el-button>
          </div>
        </div>      
      </div>
    </div>
    <!-- HTML 预览对话框 -->
    <el-dialog
      title="预览"
      v-model="htmlPreviewVisible"
      width="80%"
      :before-close="closeHtmlPreview"
      :append-to-body="true"
      top="5vh"
    >
      <iframe
        :srcdoc="htmlPreviewContent"
        style="width: 100%; height: 70vh; border: none;"
        frameborder="0"
      ></iframe>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="openNewWindowPreview">在新窗口预览</el-button>
          <el-button type="primary" @click="closeHtmlPreview">关 闭</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 视频放大弹窗 -->
    <el-dialog
      title="视频播放"
      v-model="videoDialogVisible"
      width="80%"
      :append-to-body="true"
      top="5vh"
      @close="closeVideoDialog"
    >
      <video
        :src="videoDialogUrl"
        controls
        autoplay
        style="width:100%;max-height:75vh;display:block;"
      ></video>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="downloadVideo(videoDialogUrl)">下载视频</el-button>
          <el-button type="primary" @click="closeVideoDialog">关 闭</el-button>
        </div>
      </template>
    </el-dialog>
    <app-dialog
      :dialogInfo="dialogInfo"
      :iId="openInput.iId"
      v-model:isDetail="openInput.isDetail"
      :appId="openInput.approvalId"
      v-model:addInputShow="openAddInputShow"
      :coverVal="openInput.search"
      :datatype="openInput.datatype"
      @doorUp="doorUp"
      @close="doorUpCloe" />
    <vipPay v-model:isView="vipPayShow" />
    <install-progress class="fullscreen-progress" :visible="showProgress" :text="progressText" appendToBody />
  </div>
</template>

<script>
import { nextTick, defineAsyncComponent } from 'vue'
import Axios from 'axios'
import {
//   getLogin,
//   loginAi,
//   addTalk,
//   getAddAi,
  getRobotToken
} from '@/api/openAi.js'
import { goAppId } from '@/lib/color'
import { dealText } from '@/api/common.js'
import { AI_MODEL_LIST } from '@/components/common/chat/common/aiConfig'
import { getaimodelbyid, getquestionknowledge, getaimanageconfig, getfilecontent, getsampleword, aiparsecontent } from '@/port/admins/ai'
import { openapiGetapproval } from "@/port/clientSide/oaExamineAudit";
import { momVal, setOthersFormdata } from "@/api/utils";
import widgetOneLayer from "@/components/clientSide/formFillinPageChild/widgetOneLayer";
import parmsMixins from '@/components/schoolInstrument/mixins/parmsMixins'
import application from '@/components/clientSide/applicationRouting'
import { cloneDeep } from 'lodash'
import VMdEditor from '@kangc/v-md-editor';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
import '@kangc/v-md-editor/lib/theme/style/github.css';
import mermaid from 'mermaid';
import Prism from 'prismjs';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-typescript';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-markdown';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-bash';
import ttsMixin from '@/components/common/chat/common/tts.mixin.js';
import chatMixin from '@/components/common/chat/common/chat.mixin.js';
import aiChatContent from '@/components/common/chat/index.vue'

const customHighlight = (str, lang) => {
  if (!str) return `<pre><code></code></pre>`;

  let highlightLang = lang && typeof lang === 'string' ? lang.toLowerCase() : '';
  if (highlightLang.startsWith('html') || highlightLang === 'xml') {
    highlightLang = Prism.languages.html ? 'html' : (Prism.languages.markup ? 'markup' : 'html');
  }
  if (!highlightLang || !Prism.languages[highlightLang]) {
    highlightLang = Prism.languages.markup ? 'markup' : highlightLang;
  }

  const escapeHtml = (text) => {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  };

  if (!highlightLang || !Prism.languages[highlightLang]) {
    return `<pre class="language-text"><code>${escapeHtml(str)}</code></pre>`;
  }

  try {
    const highlighted = Prism.highlight(str, Prism.languages[highlightLang], highlightLang);
    return `<pre class="language-${highlightLang}"><code class="language-${highlightLang}">${highlighted}</code></pre>`;
  } catch (e) {
    console.warn('Code highlighting failed:', e);
    return `<pre class="language-${highlightLang}"><code>${escapeHtml(str)}</code></pre>`;
  }
};

// 配置 Mermaid
mermaid.initialize({
  startOnLoad: false, // 设置为 false，由 v-md-editor 控制渲染
  theme: 'default',
  flowchart: {
    useMaxWidth: false,
  },
  securityLevel: 'loose',
});

const setupMarkdownExtension = () => {
    VMdEditor.use(githubTheme, {
        Prism,
        extend(md) {
            // 覆盖默认高亮处理器
            md.set({
                highlight: customHighlight
            });

            // Mermaid 插件
            const defaultRender = md.renderer.rules.fence;
            
            md.renderer.rules.fence = (tokens, idx, options, env, self) => {
                const token = tokens[idx];
                if (!token) {
                    return '<pre><code></code></pre>';
                }

                const lang = (token.info && typeof token.info === 'string' && token.info.trim)
                ? token.info.trim()
                : '';
                const content = token.content || '';

                // 如果是 mermaid 代码块
                if (lang === 'mermaid') {
                    try {
                        // 生成唯一 ID
                        const id = 'mermaid-' + Math.random().toString(36).substr(2, 9);
                        
                        // 返回包含 mermaid 代码的容器
                        return `<div class="mermaid-container" data-mermaid-id="${id}">
                            <div class="mermaid-code" style="display: none;">${content}</div>
                            <div id="${id}" class="mermaid-chart">正在渲染图表...</div>
                        </div>`;
                    } catch (err) {
                        // return `<pre><code>Mermaid 渲染错误: ${err.toString()}</code></pre>`;
                    }
                }

                const lowerLang = (lang || '').toLowerCase();

                const looksLikeHtml = /<!DOCTYPE\s+html>|<html[\s>]|<head[\s>]|<body[\s>]/i.test(content);

                // 如果是 HTML 代码块，添加loading状态和切换功能
                if ((lowerLang.startsWith('html') || (!lowerLang && looksLikeHtml)) && content) {
                    const htmlId = `html-code-${Date.now()}-${idx}`;
                    const highlightLang = Prism.languages.html ? 'html' : (Prism.languages.markup ? 'markup' : 'html');
                    const highlightedCode = customHighlight(content, highlightLang);

                    // 检测是否在流式渲染中（通过检查answerOver状态，这里需要通过全局变量或闭包传递）
                    // 暂时使用一个标记来判断，后续会在渲染完成后更新
                    // const isStreaming = true; // 默认在流式渲染中

                    // Loading状态的div
                    const loadingHtml = `<div class="html-code-loading" data-html-id="${htmlId}">
                        <div class="html-code-loading-content">
                        <div class="html-code-loading-text">
                            <img src="https://bigdata.topeti.com/PCRepository/mainPlatform/robot-img.gif" alt="" />
                            正在生成展示效果，预计2-5分钟，请耐心等待...
                        </div>
                        </div>
                    </div>`;

                    // 完成状态的div（初始隐藏）
                    const completedHtml = `<div class="html-code-completed" data-html-id="${htmlId}" style="display: none;">
                        <div class="html-code-completed-content">
                        <div class="html-code-completed-text">
                            <img src="https://bigdata.topeti.com/PCRepository/mainPlatform/robot-img1.png" alt="" />
                            已生成完毕可点击查看
                        </div>
                        <div class="html-code-actions" style="position:inherit;">
                            <button class="html-code-btn html-code-download" data-action="download">
                            <i class="WSiconfont WSicon-a-3"></i>下载
                            </button>
                            <button class="html-code-btn html-code-preview" data-action="preview">
                            <i class="WSiconfont WSicon-a-1"></i>预览
                            </button>
                        </div>
                        <i class="html-code-toggle-icon WSiconfont WSicon-a-4" data-action="toggle"></i>
                        </div>
                    </div>`;

                    // 代码容器（初始隐藏），包含高亮代码和按钮
                    const codeActionsHtml = `<div class="html-code-actions">
                        <button class="html-code-btn html-btn-result html-code-download" data-action="download">
                        <i class="WSiconfont WSicon-a-3"></i>下载
                        </button>
                        <button class="html-code-btn html-btn-result html-code-copy" data-action="copy">
                        <i class="WSiconfont WSicon-a-2"></i>复制
                        </button>
                        <button class="html-code-btn html-btn-result html-code-preview" data-action="preview">
                        <i class="WSiconfont WSicon-a-1"></i>预览
                        </button>
                    </div>`;

                    const codeContainer = `<div class="html-code-container" data-html-id="${htmlId}" style="display: none;">
                        ${codeActionsHtml}
                        ${highlightedCode}
                    </div>`;

                    return `<div class="html-code-block-wrapper" data-html-id="${htmlId}" data-streaming="true">
                        ${loadingHtml}
                        ${completedHtml}
                        ${codeContainer}
                    </div>`;
                }                        

                return defaultRender(tokens, idx, options, env, self);
            };
        }
    });

    console.log('Markdown扩展已注册');
};

export default {
  name: 'ChatBox',
  mixins: [parmsMixins, ttsMixin, chatMixin],
  components: {
    swipeStep: defineAsyncComponent(() => import('./components/swipeStep.vue')),
    dataTable: defineAsyncComponent(() => import('./components/dataTable.vue')),
    markdownTypewriter: defineAsyncComponent(() => import('./components/markdownTypewriter.vue')),
    buttonComp: defineAsyncComponent(() => import('../../../components/schoolInstrument/component/mutual/component/button/index.vue')),
    AppDialog: defineAsyncComponent(() => import('@/components/schoolInstrument/mixins/AppDialog.vue')),
    widgetOneLayer,
    VMdEditor,
    vipPay: defineAsyncComponent(() => import('@/components/common/vipPay/index')),
    history: defineAsyncComponent(() => import('@/components/common/chat/common/history.vue')),
    InstallProgress: defineAsyncComponent(() => import('@/components/common/installLoading.vue')),
    aiChatContent
  },
  props: {
    customDeskInfo: {
      type: Object,
      default:()=> ({})
    }
  },
  watch: {
    // 监听会话列表变化
    sessions: {
      handler() {
        this.updateScrollButtons();
      },
      deep: true
    },
    queryMessage() {
      this.adjustTextareaHeight()
    }
  },
  data() {
    return {
      aiModelId: null, // AI小易表id
      spaceId: null, // 组织空间id
      upaceId: null, // 个人空间id
      pageLoading: true, // 页面加载状态
      appName: '', // 应用名称
      stepList: [], // 步骤列表
      curStep: 0, // 当前步骤
      // 表单相关字段
      approvalId: null, // 应用id
      ruleList: [],
      formdata: null, // 值合集
      formLayout: 2,
      showTable: true, // 是否显示表格
      associationVisible:{
        key: -1,
        select: {},
        value: {},
        ruleForm: {},
      },
      bindinf: '', //生成文案
      customData: [], //页面传参
      functionParms: [], //函数变量
      otherData: {
        showQuestion: false, //是否显示问题
      }, //其他设置数据
      layout: {}, //自定义配置按钮
      modelList: [], // 模型列表
      modelConfig: [], // 用户配置的模型（多选）
      valueType: '', //当前选择技能（多模态适用）
      valueModel: '', // 模型
      valueResultType: '', //生成类型
      valueKnowledge: [], // 已选择知识库
      knowledgeOpen: 1, //知识库检索开关
      agentConfig: {}, //智能体配置
      paramConfig: {}, //预设参数
      systemSwitch: 1, //精确调参
      onlineSearch: 0, //联网搜索
      // 解析方式、ocr识别解析
      otherSet: {
        parsingMethod: 0,
        ocrCheck: 0
      },
      onlineSwitch: true, //联网搜索开关
      answerType: null, // 调用接口类型
      startRobot: false, // 是否开始分析
      robotAnimate: false, // 机器人动画
      customDeskFormInfo: {}, // 表单传参配置
      prevButton: true, // 是否显示上一页按钮
      // 初始化用户信息
      userImg:'',
      token:'',
      aiList: {},
      robotImg: 'https://bigdata.topeti.com/PCRepository/middleground/abilityManagement/default-robot.png',
      // 对话信息
      sessions: [],
      queryMessage: '',
      //思考用
      thinking: false,
      thinkContent: '',
      answerOver: true, // 回答问题状态
      showContinueBtn: false, // 是否显示继续生成按钮
      showDrag: false, //是否显示回答结束后的工具栏
      channel: '', // 渠道 appAi(表单发起/详情页ai模板跳转)
      openAddInputShow: false, // 发起单独使用的
      videoDialogVisible: false,
      videoDialogUrl: '',
      lastResponseId: '', //豆包文字接口多轮对话传递的id
      // 所有模型列表
      optionsModel: JSON.parse(JSON.stringify(AI_MODEL_LIST)),
      // 火山生图、视频自定义字段
      doubanConfig: {
        image: {
          size: [
            {
              label: '1:1',
              value: '2048x2048',
            },
            {
              label: '4:3',
              value: '2304x1728',
            },
            {
              label: '3:4',
              value: '1728x2304',
            },
            {
              label: '16:9',
              value: '2848x1600',
            },
            {
              label: '9:16',
              value: '1600x2848',
            },
            {
              label: '3:2',
              value: '2496x1664',
            },
            {
              label: '2:3',
              value: '1664x2496',
            },
            {
              label: '21:9',
              value: '3136x1344',
            }
          ]
        },
        video: {
          ratio: ['16:9', '4:3', '1:1', '3:4', '9:16', '21:9'],
          duration: Array.from({ length: 9 }, (_, i) => i + 4) // 生成4-12的数组
        }
      },
      valueDoubaoIS: '2304x1728',
      valueDoubaoVR: '4:3',
      valueDoubaoVD: 5,
      dialogInfo: {
        dialogName: '',
        isVisible: false,
        dialogWidth: '80%',
        dialogHeight: '85vh',
        openType: 'dialog',
        customSize: 65,
        dialogUrl: '',
        diaSize: '80%',
        childDialog: true
      },
      openInput: {
        isVisible: false,
        approvalId: '',
        search: {},
        iId: '',
      },
      ruleForm: {},
      renderBuffer: [], // 渲染缓冲区
      isRendering: false, // 新增渲染状态
      previewOptions: {
        linkify: true,
        breaks: true,
        html: true,
        typographer: true,
        highlight: (code, lang) => {
          return customHighlight(code, lang || '');
        }
      },
      // HTML 预览对话框状态
      htmlPreviewVisible: false,
      htmlPreviewContent: '',
      htmlPreviewIframeSrc: '',
      timer: null, // 添加计时器变量
      startTime: null, // 添加开始时间变量
      abortController: null, // 添加 AbortController
      showScrollButtons: false,
      showUpButton: false,
      showDownButton: true,
      userHasScrolled: false, // 用户滚动状态（是否滚动过）
      isScaled: false, //页面是否缩放
      vipPayShow: false, //会员支付
      appCheckList: [],
      appCheckResult: [], // 应用检索对象结果
      paramsListType2: [],
      currentSkill: null,
      isHistory: false,
      progressText: 'AI正在深度分析中，预计等待2-4分钟，请您稍候，结果生成后会自动展示，您可先处理其他事务。',
      showProgress: false,
      defaultQuestion: '',
      multiText: '', //多模态场景默认提示词
      chatBoxFloat: false,
    }
  },
  created () {
    if (this.$route.query.aiModelId || this.customDeskInfo.aiModelId) {
      this.aiModelId = this.$route.query.aiModelId || this.customDeskInfo.aiModelId
      this.getAiConfig()
    }
    if(this.customDeskInfo && this.customDeskInfo.channel){
      this.channel = this.customDeskInfo.channel
    }    
  },
  computed: {
    stepConfig() {
      const config = cloneDeep(this.stepList[this.curStep])
      const style = {
        text1: "全面支持自定义模型训练，知识库建设，打造专属AI",
        avatarId: "https://bigdata.topeti.com/mainPlatform/CottonBot.png",
        searchVal: "我是AI数据查询，需要什么帮助？",
      }
      if (config.type === 'fileGenerate') {
        config.knowledge = this.valueKnowledge
        style.searchVal = "我是AI文件查询，需要什么帮助？"
      } else if (config.type === 'contentGenerate') {
        style.searchVal = "我是AI内容创作，需要什么帮助？"
      }
      return {
        config: config,
        style
      }
    },
    // 获取第一个 user 的索引
    firstUserIndex() {
      return this.sessions.findIndex(s => s.role === 'user');
    },
    isReasonModel() {
      const m = (this.valueModel || '').trim();
      return m === 'deepseek' || m === 'yiwen' || m === 'deepseek-reasoner' || m === 'deepseek-v4-pro' || m === 'deepseek-v4-flash' ||
      m === 'zixun';
    },
    showPrevButton() {
      if (this.curStep === 0) return false;
      const prevStep = this.stepList[this.curStep - 1];
      return prevStep && prevStep.show !== false;
    },

    showNextButton() {
      // 如果已经是最后一步，返回false
      if (this.curStep >= this.stepList.length - 2) return false;
      
      // 遍历当前步骤之后的所有步骤
      for (let i = this.curStep + 1; i < this.stepList.length; i++) {
        const step = this.stepList[i];
        // 如果是生成结果步骤，跳过检查
        if (step.type === 'aiGenerate') {
          continue;
        }
        // 如果找到任何一个显示的步骤，返回true
        if (step.show !== false) {
          return true;
        }
      }
      
      // 如果没有找到任何显示的步骤，返回false
      return false;
    },

    showStartButton() {
      // 如果当前步骤不显示，直接返回false
      if (!this.stepList[this.curStep].show) {
        return false;
      }

      // 检查当前步骤之后的所有步骤（除了aiGenerate、dataWrite类型）
      for (let i = this.curStep + 1; i < this.stepList.length; i++) {
        const step = this.stepList[i];
        // 如果是生成结果步骤，跳过检查
        if (['dataWrite', 'aiGenerate', 'fileGenerate', 'contentGenerate'].includes(step.type)) {
          continue;
        }
        // 如果找到任何一个显示的步骤，返回false
        if (step.show !== false) {
          return false;
        }
      }
      
      // 确保存在生成结果步骤
      return this.stepList.some(step => ['aiGenerate', 'fileGenerate', 'contentGenerate'].includes(step.type));
    },

    leftLayout: () => {
      return (value) =>
        value.filter(
          (item) => item.isLeft === true || item.isLeft === undefined
        )
    },
    rightLayout: () => {
      return (value) => value.filter((item) => item.isLeft === false)
    },
    isComp() {
      let flag = ''
      const item = this.stepList[this.curStep].dataInfo.insideInfo
      const paramsList = this.customDeskInfo && this.customDeskInfo.paramsList ? JSON.parse(this.customDeskInfo.paramsList) : []
      const searchList =  this.customDeskInfo && this.customDeskInfo.search ? this.dealQueryStr(this.customDeskInfo.search) : {}
      console.log("searchList==",searchList);
      
      if(item.datatype === 1){
        let matchingParam;
        let query = {
          approvalId: item.appid + '',
          iId: item.appIid + '',
          source: 'user',
          name: item.appName,
          navShow: false
        }
        if(!this.stepList[this.curStep].show){
          query.tableHide = true
        }
        query[goAppId[item.appIid]] = item.appIid + ''
        if(item.linked && item.linked.length > 0){
          const linkedFields = item.linked;
          let linkedFormdata = {};    
          
          linkedFields.forEach(linkedField => {
            // 在paramsList中查找对应的参数
            matchingParam = paramsList.find(param => param.name === linkedField.name);
            // 在FormList中查找对应的字段信息
            const formField = linkedField.FormList.find(form => form.name === linkedField.conditionValue);
            if (matchingParam && formField) {
              // 使用formField的title和type构建key
              const formKey = `${formField.title}_${formField.type}`;
              // 确保值始终是数组格式，如果包含英文逗号则拆分
              linkedFormdata[formKey] = this.formatValueToArray(matchingParam.value);
              console.log("linkedFormdata[formKey]==",linkedFormdata[formKey],matchingParam.value)
            }
            else{
              const matchingCustom = this.customData.find(custom => custom.name === linkedField.name);
              if (matchingCustom && formField) {
                // 使用formField的title和type构建key
                const formKey = `${formField.title}_${formField.type}`;
                // 确保值始终是数组格式，如果包含英文逗号则拆分
                linkedFormdata[formKey] = this.formatValueToArray(matchingCustom.value);
              }
            }
          });
          // ai小易设置（AI模板传参）
          if(Object.keys(searchList).length > 0){
            linkedFields.forEach(linkedField => {
              // 构造需要匹配的键
              const keyToMatch = `${linkedField.title}_${linkedField.type}`;
              // 检查 searchList 中是否存在该键
              if (keyToMatch in searchList) {
                  // 在FormList中查找对应的字段信息
                  const formField = linkedField.FormList.find(form => form.name === linkedField.name);
                  if (formField) {
                    const formKey = `${formField.title}_${formField.type}`;
                    // 确保值始终是数组格式，如果包含英文逗号则拆分
                    linkedFormdata[formKey] = this.formatValueToArray(searchList[keyToMatch]);
                  }
            }
          });
          }
          console.log("linkedFormdata==",linkedFormdata);
          query.search = JSON.stringify(linkedFormdata)
        }
        console.log("query111==",query)
        // this.$set(this, 'customDeskFormInfo', query)
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.customDeskFormInfo = query
        flag = application
      }
      if (flag) {
        return flag
      } else {
        return false
      }
    },
    currentStepConfig () {
      return this.stepList[this.curStep]
    },
    isShowHistory () {
      return this.isHistory && (['aiGenerate', 'videoGenerate', 'imgGenerate'].includes(this.currentStepConfig.type) ? true : false)
    }
  },
  methods: {
    changeStep () {},
    // 保存会话历史记录
    saveSessionHistory(isNewDialogue) {
      if (this.isHistory && this.sessions.length > 0 && this.$refs.historyRef) {
        this.$refs.historyRef.toHistory(this.sessions)   
      }
      if (isNewDialogue) {
        this.sessions = []
      }
    },
    changeHistory (session) {
      this.sessions = cloneDeep(session)
    },
    // 新对话
    addRecord () {
      if (this.answerOver) {
        this.sessions = []
      } else {
        // 正在回答需要停止
        this.stopThinking()
        this.saveSessionHistory(true)
      }
      this.curStep = 0
      this.showDrag = false
      this.startRobot = false
      this.stepChange()
    },
    isInquire(){
      let textInfo = localStorage.getItem('currentTranscription');
      console.log(textInfo,'textInfo')
      if(textInfo){
        textInfo = JSON.parse(textInfo);
        if(textInfo.isAi){
          this.queryMessage = textInfo.text;
          setTimeout(()=>{
            this.$nextTick(() => {
              this.adjustTextareaHeight()
              this.communicate()
            })
          }, 500)
        }
        localStorage.removeItem('currentTranscription');
      }
    },
    adjustTextareaHeight() {
      this.$nextTick(() => {
        const textarea = this.$refs.editor
        if (!textarea) return
        textarea.style.height = 'auto'
        const maxHeight = 120
        textarea.style.height = Math.min(textarea.scrollHeight, maxHeight) + 'px'
        textarea.style.overflowY = textarea.scrollHeight > maxHeight ? 'auto' : 'hidden'
        this.chatBoxFloat = this.sessions.length > 0 && textarea.scrollHeight > 52
      })
    },
    // 手势返回操作
    confirmOk() {
      this.$refs.editor.blur()
      this.communicate()
    },
    // 初始化
    init() {
      this.initChatToken()
    },
    // 富文本内容解析
    getText (text) {
      const res = dealText({ 
        text,
        commonData: this.$store.state.userData, 
        customData: this.customData,
        functionParms: this.functionParms,
        stepList: this.stepList
      })
      return res || text
    },
    getInitText (text) {
      const res = dealText({ 
        text, 
        commonData: this.$store.state.userData, 
        customData: this.customData,
        functionParms: this.functionParms
      })
      console.log("asdd==",res,text);
      
      return res || text
    },
    dealQueryStr(str) {
      if (!str) return
      const query = typeof str === 'string' ? JSON.parse(str) : str
      return query
    },
    // 初始化机器人
    initChatToken() {
      if(this.valueModel === 'yiyan'){
        getRobotToken(this.token).then(res => {
          this.aiList.token = res.data.data
        })
        this.answerType = function(msg) {
          // 调用文心一言版小易
          return Axios({
            url:
              'https://aip.baidubce.com/rpc/2.0/ai_custom/v1/wenxinworkshop/chat/completions',
            method: 'post',
            headers: {
              'Content-Type': 'application/json'
            },
            params: {
              access_token: this.aiList.token
            },
            data: {
              messages: msg
            }
          })
        }
      }
      else{
        console.log("自训模型")
      }
    },
    // 复制答案
    copy(msg) {
      if (typeof msg === 'object') {
        msg = msg.imgUrl
      }
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(msg).then(() => {
          this.$message.success('复制成功')
        })
      } else {
        var textArea = document.createElement('textarea')
        textArea.value = msg
        textArea.style.position = 'absolute'
        textArea.style.opacity = '0'
        textArea.style.left = '-99999px'
        textArea.style.top = '-99999px'
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()
        document.execCommand('cpoy')
        this.$message.success('复制成功')
        textArea.remove()
      }
    },
    // 渲染 Mermaid 图表
    renderMermaidCharts() {
      this.$nextTick(() => {
          setTimeout(() => {
              const mermaidContainers = document.querySelectorAll('.mermaid-container');
              // console.log('找到 Mermaid 容器数量:', mermaidContainers.length);
              
              mermaidContainers.forEach(container => {
                  const codeElement = container.querySelector('.mermaid-code');
                  const chartElement = container.querySelector('.mermaid-chart');
                  
                  if (!codeElement || !chartElement || chartElement.classList.contains('rendered')) {
                      return;
                  }
                  
                  const mermaidCode = codeElement.textContent;
                  // console.log('Mermaid 代码:', mermaidCode);
                  
                  if (!mermaidCode.trim()) {
                      chartElement.innerHTML = '<div class="mermaid-error">图表代码为空</div>';
                      return;
                  }
                  
                  try {
                      // 设置 mermaid 代码
                      chartElement.textContent = mermaidCode;
                      chartElement.classList.add('mermaid');
                      
                      // 检查 mermaid 版本并调用相应的方法
                      if (mermaid.init && typeof mermaid.init === 'function') {
                          // Mermaid 8.x 版本 - 返回 Promise
                          const initResult = mermaid.init(undefined, chartElement);
                          
                          if (initResult && typeof initResult.then === 'function') {
                              // 如果是 Promise
                              initResult.then(() => {
                                  console.log('Mermaid 图表渲染成功');
                                  chartElement.classList.add('rendered');
                                  // this.addMermaidCopyButton(container, mermaidCode);
                              }).catch(err => {
                                  console.error('Mermaid 初始化失败:', err);
                                  this.handleMermaidError(chartElement, err);
                              });
                          } else {
                              // 如果是同步方法（Mermaid 9.x+）
                              // console.log('Mermaid 同步初始化完成');
                              chartElement.classList.add('rendered');
                              // this.addMermaidCopyButton(container, mermaidCode);
                          }
                      } else {
                          // 使用 render 方法作为备选
                          this.renderMermaidWithRenderAPI(chartElement, mermaidCode, container);
                      }
                  } catch (err) {
                      console.error('Mermaid 处理异常:', err);
                      this.handleMermaidError(chartElement, err);
                  }
              });
          }, 100);
      });
    },
    // 添加备选渲染方法
    renderMermaidWithRenderAPI(chartElement, mermaidCode) {
        try {
            // 生成唯一 ID
            const id = 'mermaid-' + Math.random().toString(36).substr(2, 9);
            chartElement.id = id;
            
            if (mermaid.render && typeof mermaid.render === 'function') {
                mermaid.render(id, mermaidCode).then(({ svg }) => {
                    chartElement.innerHTML = svg;
                    chartElement.classList.add('rendered');
                    // this.addMermaidCopyButton(container, mermaidCode);
                }).catch(err => {
                    console.error('Mermaid render 方法失败:', err);
                    this.handleMermaidError(chartElement, err);
                });
            } else {
                throw new Error('Mermaid 渲染方法不可用');
            }
        } catch (err) {
            this.handleMermaidError(chartElement, err);
        }
    },
    // 思考方法
    think(type) {
      if (type === 'thinking') {
        this.thinking = true
        this.thinkContent = 'AI小易正在生成...'
      } else {
        this.thinking = false
      }
    },
    // 检查是否需要显示滚动按钮
    checkScrollButtons() {
      const wrap = document.querySelector('#chat-msg .el-scrollbar__wrap');
      if (wrap) {
      const scrollHeight = wrap.scrollHeight;
      const clientHeight = wrap.clientHeight;
      const scrollTop = wrap.scrollTop;
        // console.log('Scroll Height:', scrollHeight);
        // console.log('Client Height:', clientHeight);
      // 判断是否需要显示滚动按钮
      this.showScrollButtons = scrollHeight > clientHeight;
      if (this.showScrollButtons) {
        // 更新上下按钮的显示状态
        this.showUpButton = scrollTop > 10; // 添加一个小阈值，避免精度问题
        this.showDownButton = scrollTop < (scrollHeight - clientHeight - 10); // 同上
      } else {
        // 如果不需要滚动，隐藏所有按钮
        this.showUpButton = false;
        this.showDownButton = false;
      }
      // 判断用户是否主动滚动且未到最底部
      const threshold = 110;
      if (scrollTop + clientHeight < scrollHeight - threshold) {
        this.userHasScrolled = true;
      } else {
        this.userHasScrolled = false;
        }
      }
    },

    // 处理滚动事件
    handleScroll() {
      nextTick(() => {
        const wrap = document.querySelector('#chat-msg .el-scrollbar__wrap');
        if (wrap) {
          const scrollHeight = wrap.scrollHeight;
          const clientHeight = wrap.clientHeight;
          const scrollTop = wrap.scrollTop;

          // 实时更新按钮显示状态
          if (scrollHeight > clientHeight) {
            this.showScrollButtons = true;
            this.showUpButton = scrollTop > 10;
            this.showDownButton = scrollTop < (scrollHeight - clientHeight - 10);
          } else {
            this.showScrollButtons = false;
            this.showUpButton = false;
            this.showDownButton = false;
          }

          // 用户离开底部即视为手动干预；回到底部则恢复自动跟随
          const threshold = 110;
          this.userHasScrolled = scrollTop + clientHeight < scrollHeight - threshold;
        }
      })
    },

    // 滚动到指定位置
    scrollToPosition(direction) {
      nextTick(() => {
        const wrap = document.querySelector('#chat-msg .el-scrollbar__wrap');
        if (wrap) {
          // 手动点击按钮时立即切换自动跟随状态
          this.userHasScrolled = direction === 'up';

          if (direction === 'up') {
            // 滚动到最上方
            wrap.scrollTop = 0;
          } else {
            // 滚动到最下方
            wrap.scrollTop = wrap.scrollHeight;
          }

          // 更新按钮显示状态
          this.handleScroll();
        }
      })
    },

    // 监听内容变化
    watchContentChanges() {
      const observer = new MutationObserver(() => {
        // 使用 requestAnimationFrame 来优化性能
        requestAnimationFrame(() => {
          this.checkScrollButtons();
        });
      });

      const config = {
        childList: true,
        subtree: true,
        characterData: true, // 添加文本内容变化的监听
        attributes: true // 添加属性变化的监听
      };
      console.log("ccc==",this.$refs.scrollArea)
      if (this.$refs.scrollArea && this.$refs.scrollArea.$el) {
        console.log("bbb")
        observer.observe(this.$refs.scrollArea.$el, config);
        this._observer = observer;
      }
    },

    // 在内容更新后重新检查按钮状态
    updateScrollButtons() {
      this.$nextTick(() => {
        this.checkScrollButtons();
      });
    },
    // 思考状态展开折叠
    toggleThinking(event) {
      // 获取当前点击的 ai-think 元素的父元素
      const parentEl = event.target.closest('.box');
      console.log("parentEl==", parentEl);
      if (!parentEl) return;

      // 查找所有可能的内容元素
      const contentElements = parentEl.querySelectorAll('div[data-v-md-line="1"], div[data-v-md-line]');
      
      if (contentElements.length > 0) {
        // 切换所有内容元素的显示状态
        contentElements.forEach(element => {
          if (element.style.display === 'none') {
            element.style.display = 'block';
      } else {
            element.style.display = 'none';
      }
        });
        
        // 切换按钮的 hide 类
          event.target.classList.toggle('hide');
      } else {
        console.warn('未找到任何内容元素');
      }
    },
    // 停止回答
    stopThinking() {
      // 中止请求
      if (this.abortController) {
        this.abortController.abort();
        this.stopPlay()
      }
    },
    // 联网搜索开关
    openOnline(){
      this.onlineSwitch = !this.onlineSwitch
    },
    // 多模态技能切换
    onMultiModalChange(val, list) {
      const item = list.find(i => i.type === val)
      if (!item) return
      console.log("item====",item)
      this.modelConfig = !Array.isArray(item.valueModel) ? [item.valueModel] : item.valueModel
      console.log("this.modelConfig====",this.modelConfig)
      if (this.modelConfig && this.modelConfig.length > 0) {
        // 根据 number 筛选 optionsModel
        this.modelList = this.optionsModel.filter(model =>
          this.modelConfig.includes(model.value)
        ).map(model => ({
          value: model.value,
          label: model.name
        }));
        console.log("Filtered modelList00:", this.modelList);

        // 如果当前选中的模型不在筛选结果中，设置为第一个可用模型
        if (this.modelList.length > 0 && !this.modelList.some(m => m.value === this.valueModel)) {
          this.valueModel = this.modelList[0].value;
        }
      }
      this.valueType = item.type
      this.onlineSearch = item.onlineSearch !== undefined ? item.onlineSearch : 0
      this.otherSet = item.otherSet !== undefined ? item.otherSet : {
        parsingMethod: 0,
        ocrCheck: 0
      }
      this.valueKnowledge = item.valueKnowledge !== undefined ? item.valueKnowledge : []
      this.knowledgeOpen = item.knowledgeOpen ? item.knowledgeOpen : 1
    },
    // 清空记录
    clearHistory() {
      this.$confirm('确定要清空记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.sessions = [];
        this.sessionsHistory = [];
        this.currentSessionIndex = 0;
        this.$message({
          type: 'success',
          message: '记录清空成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 打字机效果-回答完成
    finishAnswer(){
      this.showDrag = true;
    },
    // 交流方法
    async communicate() {
      // 判断是否有对话内容
      if (this.queryMessage === '' || this.queryMessage === '\n') {
        this.queryMessage = ''
        this.$message.error('请输入对话消息')
        return
      }
      if(this.thinking){
        this.$message.warning('正在努力分析中，请勿重复提交')
        return
      }
      const block = document.getElementById('chat-msg')
      // 如果是多模态场景，要在用户输入内容的基础上加上默认提示词
      let sendMessage = this.multiText ? this.multiText + this.queryMessage : this.queryMessage
      // // 如果配置了联网搜索，并且打开
      // if(this.onlineSearch && this.onlineSwitch){
      //   const searchAppend = await this.goOnlineSearch(sendMessage)
      //   if (searchAppend) {
      //     sendMessage = sendMessage + searchAppend
      //   }
      // }
      // 用户询问
      this.sessions.push({
        role: 'user',
        content: sendMessage
      })
      this.$nextTick(function() {
        if (block.scrollHeight) block.scrollTop = block.scrollHeight
      })
      
      // 调用机器人接口
      this.startAi()
    },
    async getKnowledge(val){
      let sendMessage = val
      let userMsg = localStorage.getItem("userMsg")
      let schoolId = null
      let konwledgeVal = ''
      if (userMsg) {
        schoolId = JSON.parse(userMsg).schoolMsg.schoolId
      }
      for (let i = 0; i < this.valueKnowledge.length; i++) {
        const query = {
          question: this.knowledgeOpen ? sendMessage : this.bindinf, //判断是否开启知识库检索
          schoolId: schoolId,
          knowledgeBaseId: this.valueKnowledge[i],
        }
        console.log("query==",query);
        
        const { code, data } = await getquestionknowledge(query)
        if (code === 0 && data !== '') {
          konwledgeVal += `<div style='display: none;'> ${data}</div>`
        }
      }
      sendMessage += konwledgeVal
      const lastSession = this.sessions[this.sessions.length - 1];
      lastSession.content = sendMessage
      return lastSession
    },
    async startAi() {
      this.stopPlay()
      this.searchApp()
      let msg = ''
      const block = document.getElementById('chat-msg')
      if(this.thinking){
        this.$message.warning('正在努力分析中，请勿重复提交')
        return
      }
      this.think('thinking')      
      this.showDrag = false
      this.answerOver = false
      let sessionsClone = cloneDeep(this.sessions)
      console.log("sessionsClone==",sessionsClone)
      // 删除所有对象的 time 和 thinking 字段,避免重复提交的时候deepseek-r1:14b接口报错
      sessionsClone.forEach(item => {
          delete item.time;
          delete item.thinking;
      });
      if(this.valueModel === 'yiyan'){
        this.answerType(sessionsClone).then(res => {
          this.think('thinkout')
          this.answerOver = true
          this.robotAnimate = false
          msg = res.data.result
          if(!this.startRobot) return;
          this.sessions.push({
            role: 'assistant',
            content: msg,
            id: Date.now(),
            time: 0,
            thinking: true
          })
          this.saveSessionHistory()
          this.addMsg(msg)
        })
      }
      else if (this.valueModel === 'doubao-video') {
        const sendMessage = this.queryMessage ? this.queryMessage : this.filterHtmlTags(sessionsClone[sessionsClone.length - 1].content)
        console.log("sendMessage==",sendMessage)
        this.genDoubaoVideo(this.multiText ? this.multiText + sendMessage : sendMessage, this.valueDoubaoVR, this.valueDoubaoVD)
      }
      else if (this.valueModel === 'doubao-image') {
        const sendMessage = this.queryMessage ? this.queryMessage : this.filterHtmlTags(sessionsClone[sessionsClone.length - 1].content)
        this.genDoubaoImage(this.multiText ? this.multiText + sendMessage : sendMessage, this.valueDoubaoIS)
      }
      else if (this.valueModel === 'gemini-3.1-flash' || this.valueModel === 'gemini-3-pro') {
        const sendMessage = this.queryMessage ? this.queryMessage : this.filterHtmlTags(sessionsClone[sessionsClone.length - 1].content)
        const modelVal = this.valueModel === 'gemini-3.1-flash' ? 'gemini-3.1-flash-image-preview' : 'gemini-3-pro-image-preview'
        this.genGeminiImage(this.multiText ? this.multiText + sendMessage : sendMessage, modelVal)
      }
      else if (this.valueModel === 'gpt-image-2') {
        const sendMessage = this.queryMessage ? this.queryMessage : this.filterHtmlTags(sessionsClone[sessionsClone.length - 1].content)
        this.genGptImage(this.multiText ? this.multiText + sendMessage : sendMessage, this.valueModel)
      }
      else{
        console.log("自训模型==",sessionsClone)
        // 创建新的 AbortController
        this.abortController = new AbortController();
        this.queryMessage = ''
        let obj = {
          model: 'llamawxs',
          messages: sessionsClone,
          stream: false
        }
        let latestSession = this.sessions[this.sessions.length - 1]

        // 如果配置了知识库
        if (this.valueKnowledge && this.valueKnowledge.length > 0 && latestSession) {
          console.log("sessionCont==", latestSession.content);
          const lastSession = await this.getKnowledge(this.filterHtmlTags(latestSession.content));
          console.log("lastSession==", lastSession);
          // 超过128KB则截取前128KB
          const MAX_LEN = 128 * 1024;
          if (lastSession && typeof lastSession.content === 'string' && lastSession.content.length > MAX_LEN) {
            lastSession.content = lastSession.content.slice(0, MAX_LEN);
          }
          this.sessions.splice(this.sessions.length - 1, 1, lastSession)
          latestSession = this.sessions[this.sessions.length - 1]
          obj.messages = this.sessions;
        }

        // 如果配置了联网搜索，并且打开
        if (this.onlineSearch && this.onlineSwitch && latestSession) {
          const searchAppend = await this.goOnlineSearch(latestSession.content)
          if (searchAppend) {
            latestSession = {
              ...latestSession,
              content: `${latestSession.content}${searchAppend}`
            }
            this.sessions.splice(this.sessions.length - 1, 1, latestSession)
            obj.messages = this.sessions
          }
        }

        const config = {
          method: "POST",
          headers: {
              Authorization: "Bearer " + "token",
              "Content-Type": "application/json",
          },
          body: JSON.stringify(obj),
          signal: this.abortController.signal // 添加 signal
        }
        let _url = 'https://wxs.topeti.com/api/chat'
        const user = window.localStorage.getItem('user')
        // 公共调用写法
        let accesstoken = ''
        if (user) {
          accesstoken = JSON.parse(user).accesstoken
        }
        const applyTopetiHeaders = () => {
          config.headers.accesstoken = accesstoken
          config.headers.originapi = this.$url
          delete config.headers.Authorization
        }
        const setupStreamModel = (model, url) => {
          obj.model = model
          obj.stream = true
          _url = url
          applyTopetiHeaders()
        }
        const setupGeminiStreamModel = (model, url) => {
          obj.model = model
          obj.stream = true
          obj.temperature = 0.1
          obj.top_p = 1.0
          _url = url
          applyTopetiHeaders()
        }
        switch (this.valueModel) {
          // 电信模型
          case 'dx-deepsek671b':
            obj.model = '/data/nvme0/models/DeepSeek-R1-AWQ'
            obj.stream = true
            _url = 'https://eduxm.topeti.com/v1/chat/completions'
            break
          // 本地部署deeepseek
          case 'deepseek':
          case 'yiwen':
            obj.model = 'deepseek-r1:14b'
            obj.stream = true
            break
          // 千问大模型
          case 'zixun': {
            setupStreamModel('qwen3.7-max', 'https://user.topeti.com/qwen/chat')
            break
          }
          // 官方满血deepseek
          case 'deepseek-reasoner':
          case 'deepseek-chat':
          case 'deepseek-v4-flash':
          case 'deepseek-v4-pro': {
            // 知识库使用前先调用这个接口将返回值拼接到问题后面
            console.log("this.valueModel==",this.valueModel,this.valueKnowledge);            
            obj.model = this.valueModel
            obj.stream = true
            // v4 flash关闭思考过程
            if(this.valueModel === 'deepseek-v4-flash'){
              obj.extra_body = {"thinking": {"type":"disabled"}}
            }
            _url = 'https://user.topeti.com/deepseek/chat'
            applyTopetiHeaders()
            break
          }
          case 'gpt-5.4':
          case 'gpt-5.5': {
            setupStreamModel(this.valueModel, 'https://user.topeti.com/nicerouter/chat/v1/chat/completions')
            break
          }
          case 'claude-opus-4-7': {
            setupStreamModel(this.valueModel, 'https://user.topeti.com/nicerouter/ccmax/v1/messages')
            break
          }
          case 'gemini-3.1-pro-preview': {
            setupGeminiStreamModel(this.valueModel, 'https://user.topeti.com/nicerouter/gmtext/v1/chat/completions')
            break
          }
          // 豆包文字
          case 'doubao-text': {
            const sessionCont = this.sessions[this.sessions.length - 1];
            console.log("sessionCont==", sessionCont.content);
            obj.model = 'doubao-seed-2-0-pro-260215'
            obj.stream = true
            // 如果存在上一个响应ID，则用于多轮对话
            if (this.lastResponseId) {
                obj.previous_response_id = this.lastResponseId
            }
            obj.input = [
                {
                    "role": "user",
                    "content": [
                        {
                            "type": "input_text",
                            "text": sessionCont.content
                        }
                    ]
                }
            ]
            _url = 'https://user.topeti.com/doubao/api/v3/responses'
            applyTopetiHeaders()
            delete obj.messages
            break
          }
        }
        config.body = JSON.stringify(obj)
        console.log("config==",config);
        
        fetch(_url, config)
        .then(response => {
            // if (this.sessions.length === 1 && this.queryMessage) {
            //     this.sessions[0].content = this.queryMessage
            // }
            this.queryMessage = ''
            // 添加思考标签
            this.sessions.push({
                role: 'assistant',
                content: '',
                id: Date.now(),
                time: 0,
                thinking: true
            });
            this.think('thinkout');
            this.robotAnimate = false;
            this.handleStreamResponse(response)
        })
        .catch(error => {
          console.error('Fetch error:', error);
          this.think('thinkout');
          this.robotAnimate = false;
          this.answerOver = true
        });  
      }
      this.$nextTick(function() {
        if (block && block.scrollHeight) block.scrollTop = block.scrollHeight
      })
    },
    async searchApp () {
      this.appCheckResult = []
      if (this.appCheckList.length > 0 && this.queryMessage) {
        const query = {
          data: this.appCheckList,
          content: this.queryMessage
        }
        const { code, data } = await getsampleword(query)
        if (code === 0) {
          this.appCheckResult = data.map(item => { return this.getBtnInfo(item) })
          this.addAppCheckResult()
        }
      }
    },

    addAppCheckResult () {
      if (this.appCheckResult.length > 0) {
        const lastSession = this.sessions[this.sessions.length - 1];
        if (lastSession.role === 'assistant') {
          lastSession.appCheckResult = this.appCheckResult
          this.appCheckResult = []
        }
      }
    },
    getBtnInfo (item) {
      const obj = {
        info: {
          icon: item.icon,
          btnName: item.aliasName
        }
      }
      if (item.type === 'page') {
        obj.info.bindingFunction = 'custom-scene'
        obj.info.customScene = {
          id: item.id,
          params: item.name
        }
        obj.info.insideInfo = {
          open: 2,
          popUps: {
            h: 800,
            w: 1700,
          }
        }

      } else {
        obj.info.bindingFunction = 'inside'
        obj.info.insideInfo = {
          link: 2,
          open: 2,
          appIid: item.appIid,
          datatype: item.datatype,
          appid: item.id,
          linked: [],
          customize: [],
          popUps: {
            h: 800,
            w: 1700,
          }
        }
      }
      return obj
    },
    // 格式化文件大小
    formatFileSize(contentLength) {
      // 假设每个字符占用 2 字节（UTF-16编码）
      const bytes = contentLength * 2;
      const units = ['B', 'KB', 'MB', 'GB'];
      let size = bytes;
      let unitIndex = 0;

      while (size >= 1024 && unitIndex < units.length - 1) {
          size /= 1024;
          unitIndex++;
      }

      return size > 0 ? `${Math.round(size)}${units[unitIndex]}` : '0B';
    },
    // 过滤HTML标签的方法
    filterHtmlTags(str) {
      if (!str) return '';
      // 移除所有HTML标签
      return str.replace(/<[^>]+>/g, '')
      // 替换HTML实体
      .replace(/&nbsp;/g, ' ')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&')
      .replace(/&quot;/g, '"')
      // 移除多余空格
      .replace(/\s+/g, ' ')
      .trim();
    },
    // 清理HTML中的style内容
    cleanHtmlStyle(html) {
      return html.replace(/\s*style="[^"]*"/gi, '');
    },
    // 继续写、重新写
    goAnswer(val){
      console.log("val==",val);
      let sendMessage = this.getText(val)
      // 清理style内容
      sendMessage = this.cleanHtmlStyle(sendMessage)
      console.log("sendMessage111==",sendMessage)
      // 用户询问
      this.sessions.push({
        role: 'user',
        content: sendMessage
      })
      this.startAi(sendMessage)
    },
    // 获取最新答题结果（避免渲染没完成获取的数据不完整）
    getResultMsg(){
      const lastSession = this.sessions[this.sessions.length - 1]
      if (lastSession) {
        this.addMsg(lastSession.content)
      }
    },
    // 答题结果传入按钮组件
    addMsg(msg) {
      for(let i = 0; i < this.layout.info.length; i++) {
        if(this.layout.info[i].info.bindingFunction === 'inside') {
          const value = {};
          const linkedFields = this.layout.info[i].info.insideInfo.linked || [];
          linkedFields.forEach(field => {
            const key = `${field.title}_${field.type}`;
            console.log("key===",key)
            // 答题结果
            if(key === 'aiResult_text') {
              value[key] = msg;            
            }
            else {
              // 页面入参
              if(field.fatherType === 'custom_text'){
                this.customData.forEach(item => {
                  if(item.title + '_' + item.type === key && item.value) {
                    value[key] = item.value
                  }
                });
              }
              else{
                this.stepList.forEach(step => {
                  if(step.formdata && step.formdata[key] !== undefined) {
                    value[key] = step.formdata[key];
                  }
                });
              }
            }
          });
          console.log("value==",value)
          this.layout.info[i].info.insideInfo.value = value;
        }
      }
    },
    // 获取AI小易配置
    async getAiConfig(){
      const res = await getaimodelbyid({aiModelId: this.aiModelId})
      if(res.code === 0){
        const data = JSON.parse(res.data.config)
        this.appName = res.data.appname
        this.stepList = data.stepList
        let valueModel = data.valueModel
        if (!Array.isArray(valueModel) && !valueModel) {
          valueModel = this.stepList[this.stepList.length - 1].valueModel
        }
        this.modelConfig = !Array.isArray(valueModel) ? [valueModel] : valueModel
        this.valueResultType = data.valueResultType
        this.valueKnowledge = data.valueKnowledge || []
        this.knowledgeOpen = data.knowledgeOpen || 1
        this.layout = data.aiResultConfig
        this.isHistory = data.isHistory || false
        this.appCheckList = data.appCheckList || []
        this.agentConfig = data.agentConfig || {}
        this.paramConfig = data.paramConfig || {
          bindinf: '',
        }
        this.systemSwitch = data.systemSwitch === 0 ? 0 : 1
        this.onlineSearch = data.onlineSearch || 0        
        this.otherSet = data.otherSet || {
          parsingMethod: 0,
          ocrCheck: 0
        }
        this.customData = data.customData
        this.currentSkill = data.currentSkill || null
        // 多模态默认传第一个技能的值
        if(this.currentSkill && this.currentSkill.value === 'multiModal'){
          this.currentSkill.list = this.stepList.filter(item => 
            item.type !== 'dataForm' && item.type !== 'dataTable'
          )
          this.modelConfig = !Array.isArray(this.currentSkill.list[0].valueModel) ? [this.currentSkill.list[0].valueModel] : this.currentSkill.list[0].valueModel
          this.valueType = this.currentSkill.list[0].type
          this.valueKnowledge = this.currentSkill.list[0].valueKnowledge || []
          this.knowledgeOpen = this.currentSkill.list[0].knowledgeOpen || 1
          this.onlineSearch = this.currentSkill.list[0].onlineSearch || 0
          this.otherSet = this.currentSkill.list[0].otherSet || {
            parsingMethod: 0,
            ocrCheck: 0
          }
        }
        else{
          // 如果是问答模式，从 stepList 中找到 aiGenerate 步骤，优先使用其配置覆盖顶层配置
          const aiGenerateStep = (data.stepList || []).find(step => step.type === 'aiGenerate')
          if (aiGenerateStep) {
            if (aiGenerateStep.onlineSearch !== undefined) this.onlineSearch = aiGenerateStep.onlineSearch
            if (aiGenerateStep.valueKnowledge !== undefined) this.valueKnowledge = aiGenerateStep.valueKnowledge
            if (aiGenerateStep.knowledgeOpen !== undefined) this.knowledgeOpen = aiGenerateStep.knowledgeOpen
            if (aiGenerateStep.valueResultType !== undefined) this.valueResultType = aiGenerateStep.valueResultType
          }
        }
        // 页面传参
        if(this.customDeskInfo && this.customDeskInfo.paramsList) {
          this.paramsList = JSON.parse(this.customDeskInfo.paramsList)
          // 如果存在解析数据的值，则替换
          this.paramsList.forEach(item => {
            if(item.value === 'dataAnalysisStorage') {
              const localValue = localStorage.getItem('dataAnalysisStorage');
              if (localValue !== null) {
                item.value = localValue;
              }
            }
          });                
        }
        if (this.customDeskInfo?.paramsListType2) {
          const customType = {}
          this.customData.forEach(item => {
            customType[item.name] = item.type
          })
          this.paramsListType2 = JSON.parse(this.customDeskInfo.paramsListType2).map(item => {
            Object.keys(item).forEach(key => {
              const type = customType[key]
              const value = type === 'image' && typeof item[key] === 'string' ? JSON.parse(item[key]) : item[key]
              item[key] = { value, type }
            })
            return item
          })
        }
        const resList = await this.setParams({ customData: cloneDeep(this.customData) }, null, true)
        this.customData = resList || this.customData
        console.log("resList==",resList);
        console.log("this.customData==",this.customData);
        // 如果存在ai模板传参
        if(this.customDeskInfo && this.customDeskInfo.customData){
          const customData =  this.customDeskInfo && this.customDeskInfo.customData ? this.dealQueryStr(this.customDeskInfo.customData) : {}
          console.log("customData==",customData);
          // 遍历customData的key，检查是否能和this.customData的title+type匹配
          Object.keys(customData).forEach(key => {
            // 在this.customData中查找匹配项
            const matchingCustomItem = this.customData.find(item => {
              // 构造匹配键 (title_type)
              const matchKey = `${item.title}_${item.type}`;
              console.log("matchKey==",matchKey,key);
              return matchKey === key;
            });
            console.log("matchingCustomItem==",matchingCustomItem);
            // 如果找到匹配项，更新其value
            if (matchingCustomItem) {
              matchingCustomItem.value = customData[key];
            }
          });
        }
        this.functionParms = data.functionParms        
        if(this.functionParms.length > 0 && this.customData.length > 0 && this.knowledgeOpen){
          // 以下代码会导致data.bindinf中带$的值被修改
          this.bindinf = this.getInitText(data.bindinf)
        }
        else{
          this.bindinf = data.bindinf
        }
        if(data.otherData){
          this.otherData = data.otherData
        }
        await this.getAiName()
        this.init()
        this.stepChange()
      } else if (res.code === 8888){
        this.$message.error('您还未开通会员，请先开通')
        this.vipPayShow = true
      } else {
        this.$message.error(res.msg);
      }
    },
    // 获取ai头像
    async getAiName() {
      const res = await getaimanageconfig()
      if (res.code === 0) {
          this.optionsModel.forEach(ai => {
              res.data.forEach(item => {
                  if (ai.number === item.number) {
                      ai.name = item.name;
                  }
              });
          });
          if (this.modelConfig && this.modelConfig.length > 0) {
              // 根据 number 筛选 optionsModel
              this.modelList = this.optionsModel.filter(model =>
                  this.modelConfig.includes(model.value)
              ).map(model => ({
                  value: model.value,
                  label: model.name
              }));

              console.log("Filtered modelList00:", this.modelList);

              // 如果当前选中的模型不在筛选结果中，设置为第一个可用模型
              if (this.modelList.length > 0 && !this.modelList.some(m => m.value === this.valueModel)) {
                  this.valueModel = this.modelList[0].value;
              }
          }
          // 处理AI形象配置
          const skinConfig = res.data.find(item => item.number === 99);
          console.log("skinConfig==",skinConfig)
          if(skinConfig && skinConfig.info.avatar){
            this.robotImg = skinConfig.info.avatar
          }
      } else {
          this.$message.error(res.msg);
      }
    },
    // 获取表单配置
    async getApproval (id) {
      let data = {
        approvalId: id
      };
      this.approvalId = id
      const res = await openapiGetapproval(data)
      console.log("res==",res);
      
      if(res.code === 0){
        let allFormdata = {};
        const paramsList = this.customDeskInfo && this.customDeskInfo.paramsList ? JSON.parse(this.customDeskInfo.paramsList) : []
        const searchList =  this.customDeskInfo && this.customDeskInfo.search ? this.dealQueryStr(this.customDeskInfo.search) : {}
        console.log("searchList==",searchList);
        const storageKeys = ['dataAnalysisStorage', 'fileAnalysisStorage'];
        // 如果存在解析数据的值，则替换
        paramsList.forEach(item => {
          if(item.value === 'dataAnalysisStorage') {
            const localValue = localStorage.getItem('dataAnalysisStorage');
            if (localValue !== null) {
              item.value = localValue;
            }
          }
          else if(item.value === 'fileAnalysisStorage') {
            const localValue = localStorage.getItem('fileAnalysisStorage');
            if (localValue !== null) {
              item.value = localValue;
            }
          }
        });
        for (const key in searchList) {
          if (storageKeys.includes(searchList[key])) {
            const localValue = localStorage.getItem(searchList[key]);
            if (localValue !== null) {
              searchList[key] = localValue; // 替换对象的值
            }
          }
        }
        this.pageLoading = false
        this.ruleList  = [...this.ruleList, ...JSON.parse(res.data.property)]
        this.templateFun(res.data);
        if (res.data.layout) this.formLayout = res.data.layout;        
        // 如果有存在值，就直接传值
        if(this.stepList[this.curStep].formdata){
          allFormdata = this.stepList[this.curStep].formdata
        }
        console.log("allFormdata==",allFormdata);
        if(allFormdata && Object.keys(allFormdata).length > 0){
          Object.keys(allFormdata).forEach(key => {
            // 获取下划线后的字符串
            let suffix = key.split('_').pop();
            // 检查下划线后的字符串是否为 'relation-user'
            if ((suffix === 'relation-user' || suffix === 'organization' || suffix === 'roule') && typeof allFormdata[key] === 'string') {
              try {
                  // 尝试将字符串转换为JSON对象（数组）
                  allFormdata[key] = JSON.parse(allFormdata[key].replace(/'/g, '"'));
              } catch (e) {
                  console.error('解析出错:', e);
              }
            }
          });
          this.formdata = this.stepList[this.curStep].formdata
          console.log("存在值", this.formdata)
        }
        else{
          let formdata = momVal(JSON.parse(res.data.property)) //获取formdata字段
          allFormdata = res.data.formdata ? JSON.parse(res.data.formdata) : {}; //内容记取
          if(allFormdata.daliu) delete allFormdata.daliu; 
          // 传参
          if (this.stepList[this.curStep].dataInfo.insideInfo.linked && this.stepList[this.curStep].dataInfo.insideInfo.linked.length > 0) {
            const linkedFields = this.stepList[this.curStep].dataInfo.insideInfo.linked;
            let linkedFormdata = {};
            linkedFields.forEach(linkedField => {
              // 在paramsList中查找对应的参数
              const matchingParam = paramsList.find(param => param.name === linkedField.name);
              console.log("linkedField==",linkedField);
              // 在ruleList中查找匹配的规则
              const matchingRule = this.ruleList.find(rule => rule.name === linkedField.conditionValue);
              // 如果传参有值，则直接赋值
              if (matchingParam && matchingRule) {
                const formKey = `${matchingRule.title}_${matchingRule.type}`;
                linkedFormdata[formKey] = matchingParam.value;
              }
              else{
                const matchingCustom = this.customData.find(custom => custom.name === linkedField.name);
                console.log("matchingCustom==",matchingCustom, matchingRule);
                
                if (matchingCustom && matchingRule) {
                    const formKey = `${matchingRule.title}_${matchingRule.type}`;                    
                    // 判断匹配的值是否是数组，并且包含response字段，如果包含则匹配的文件解析传参
                    if (Array.isArray(matchingCustom.value) && matchingCustom.value.some(item => 'response' in item)) {
                      const localValue = localStorage.getItem('fileAnalysisStorage');
                      console.log("localValuelocalValue==",localValue);
                      
                      if (localValue !== null) {
                        linkedFormdata[formKey] = localValue;
                      }
                      else {
                        linkedFormdata[formKey] = '';
                      }
                    } else {
                      linkedFormdata[formKey] = matchingCustom.value;
                    }
                }
              }
            });
            // ai小易设置（AI模板传参）
            if(Object.keys(searchList).length > 0){
              linkedFields.forEach(linkedField => {
                // 构造需要匹配的键
                const keyToMatch = `${linkedField.title}_${linkedField.type}`;
                // 检查 searchList 中是否存在该键
                if (keyToMatch in searchList) {
                    // 在ruleList中查找匹配的规则
                    const matchingRule = this.ruleList.find(rule => rule.name === linkedField.conditionValue);
                    console.log("matchingRule==",matchingRule);
                    
                    if (matchingRule) {
                      const formKey = `${matchingRule.title}_${matchingRule.type}`;
                      linkedFormdata[formKey] = searchList[keyToMatch];
                    }
                    console.log("linkedFormdata==",linkedFormdata);
                }
              });
            }
            allFormdata = {   
              ...formdata,           
              ...allFormdata,
              ...linkedFormdata,
              ...this.stepList[this.curStep].formdata
            };
          }
          else{
            allFormdata = {   
              ...formdata,           
              ...allFormdata,
              ...this.stepList[this.curStep].formdata
            };
          }
          if(allFormdata && Object.keys(allFormdata).length > 0){
            this.formdata = allFormdata
          }
          // 设置传参的同时设置关联可见后不生效添加如下代码
          let ruleList = JSON.parse(res.data.property)
          let OthersFormdata = setOthersFormdata(ruleList, this.formdata);
          this.associationVisible = OthersFormdata.associationVisible;
          console.log("不存在值", this.formdata)
        }
        // 默认值联动
        setTimeout(() => { if (this.$refs.widgetOneLayerRef && this.$refs.widgetOneLayerRef.linkageInitiali) this.$refs.widgetOneLayerRef.linkageInitiali(-1) }, 500)
        // 如果当前步骤不显示，则跳到下一个步骤
        if(!this.stepList[this.curStep].show){
          setTimeout(() => {
            this.nextStep()
          }, 1500)
        }
        else{
          // ai小易加载完成后，如果存在用户手动输入的步骤，则关闭loading
          this.$emit('loadCallBack', this.agentConfig)
        }
      }
    },
    // 处理值转换为数组：如果包含英文逗号则拆分，否则转为数组
    formatValueToArray(value) {
      if (Array.isArray(value)) {
        return value;
      }
      if (typeof value === 'string' && value.includes(',')) {
        // 如果字符串包含英文逗号，按逗号分割并去除空格
        return value.split(',').map(item => item.trim()).filter(item => item);
      }
      return [value];
    },
    // 关闭弹窗
    closePop(){
      this.$emit('close')
    },
    // 上一步
    prevStep () {
      if(this.stepList[this.curStep].type === 'dataTable'){
        this.showTable = false;
        setTimeout(() => {
          this.showTable = true;
        }, 50);
      }
      this.curStep -= 1
      this.stepChange()
    },
    // 下一步
    nextStep () {
      if(this.stepList[this.curStep].type === 'dataForm'){
        this.submitForm()
      }
      else if(this.stepList[this.curStep].type === 'dataTable'){
        console.log("this.$store.state.aiTableData==",this.$store.state.aiTableData)
        const tableData = JSON.parse(JSON.stringify(this.$store.state.aiTableData))
        const result = {};
        console.log("tableData==",tableData);
        if(tableData.length === 0){
          this.$confirm('未选择数据，是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.stepList[this.curStep].formdata = {}
            this.showTable = false;
            setTimeout(() => {
              this.showTable = true;
            }, 50);
            this.curStep += 1
            this.stepChange()
          }).catch(() => {  
          });
        }
        else{
          // 工坊
          if(this.stepList[this.curStep].dataInfo.insideInfo.datatype === 2){
            tableData.forEach(item => {
              Object.entries(item).forEach(([key, value]) => {
                if (!result[`${key}`]) {
                  result[`${key}`] = [];
                }
                result[`${key}`].push(value);
              });
            });

            // 将数组转换为逗号分隔的字符串
            Object.keys(result).forEach(key => {
              result[key] = result[key].join(',');
            });
          }
          // 常规表单
          else{
            const appArr = this.stepList[this.curStep].dataInfo.insideInfo.appArr || this.stepList[this.curStep].dataInfo.appArr;
            const titleTypeMap = {};
            appArr.forEach(app => {
              titleTypeMap[app.title] = app.type;
            });
            tableData.forEach(item => {
              if(item.content) {
                item.content.forEach(field => {
                  const key = `${field.title}_${field.type}`;
                  if (!result[key]) {
                result[key] = [];
                  }
                  result[key].push(field.value);
                });
              } else {
                Object.entries(item).forEach(([fieldKey, fieldValue]) => {
                const matchedType = titleTypeMap[fieldKey];
                  if(matchedType) {
                    const key = `${fieldKey}_${matchedType}`;
                if (!result[key]) {
                      result[key] = [];
                    }
                    result[key].push(fieldValue);
                  }
                });
              }
            });
            Object.keys(result).forEach(key => {
              result[key] = result[key].join(',');
            });
          }
          console.log("result==",result);
          this.stepList[this.curStep].formdata = result;
          this.stepList[this.curStep].allFormdata = tableData;
          this.showTable = false;
          setTimeout(() => {
            this.showTable = true;
          }, 50);
          this.curStep += 1
          this.stepChange()
        }
        this.$store.commit('getTableData', []);
      }
    },
    // 停止分析
    stopRobot () {
      this.startRobot = false;
      this.think('thinkout')
      this.sessions = [];
      this.prevStep()
    },
    // 步骤切换
    async stepChange () {
      this.ruleList = []
      this.formdata = null
      if (this.stepList[this.curStep].type === 'dataForm') {
        console.log("步骤切换==数据表单", this.curStep);
        this.getApproval(this.stepList[this.curStep].dataInfo.insideInfo.appid)
      }
      else if (this.stepList[this.curStep].type === 'dataTable') {
        console.log("步骤切换==数据表格");
        this.$store.commit('getTableData', []);
        // ai小易表格配置隐藏
        if (!this.stepList[this.curStep].show) {
          this.prevButton = false;
          this.pageLoading = true;
          // 添加轮询检查tableData
          const startTime = Date.now();
          const timeout = 8000; // 8秒超时
          const checkTableData = () => {
            const tableData = JSON.parse(JSON.stringify(this.$store.state.aiTableData))
            console.log("tableData11==", tableData);
            // 检查是否超时
            if (Date.now() - startTime > timeout) {
              console.log("轮询超时，跳过处理");
              this.stepList[this.curStep].allFormdata = tableData;
              this.showTable = false;
              this.prevButton = true;
              this.pageLoading = false;
              this.curStep += 1
              this.stepChange()
              return;
            }
            if (tableData.length === 0) {
              // 设置轮询
              setTimeout(checkTableData, 500);
            } else {
              // 有数据时执行后续逻辑
              const result = {};
              // 工坊
              if (this.stepList[this.curStep].dataInfo.insideInfo.datatype === 2) {
                tableData.forEach(item => {
                  Object.entries(item).forEach(([key, value]) => {
                    if (!result[`${key}`]) {
                      result[`${key}`] = [];
                    }
                    result[`${key}`].push(value);
                  });
                });

                // 将数组转换为逗号分隔的字符串
                Object.keys(result).forEach(key => {
                  result[key] = result[key].join(',');
                });
              }
              // 常规表单
              else {
                const appArr = this.stepList[this.curStep].dataInfo.insideInfo.appArr || this.stepList[this.curStep].dataInfo.appArr;
                const titleTypeMap = {};
                appArr.forEach(app => {
                  titleTypeMap[app.title] = app.type;
                });
                tableData.forEach(item => {
                  if (item.content) {
                    item.content.forEach(field => {
                      const key = `${field.title}_${field.type}`;
                      if (!result[key]) {
                        result[key] = [];
                      }
                      result[key].push(field.value);
                    });
                  } else {
                    Object.entries(item).forEach(([fieldKey, fieldValue]) => {
                      const matchedType = titleTypeMap[fieldKey];
                      if (matchedType) {
                        const key = `${fieldKey}_${matchedType}`;
                        if (!result[key]) {
                          result[key] = [];
                        }
                        result[key].push(fieldValue);
                      }
                    });
                  }
                });
                Object.keys(result).forEach(key => {
                  result[key] = result[key].join(',');
                });
              }
              console.log("result====", result);
              this.pageLoading = false
              this.prevButton = true;
              this.stepList[this.curStep].formdata = result;
              this.stepList[this.curStep].allFormdata = tableData;
              this.showTable = false;
              setTimeout(() => {
                this.showTable = true;
              }, 50);
              this.curStep += 1
              this.stepChange()
            }
          }
          // 启动首次检查
          checkTableData();
        }
        else {
          // ai小易加载完成后，如果存在用户手动输入的步骤，则关闭loading
          this.pageLoading = false
          this.$emit('loadCallBack')
        }
      }
      else if (this.currentSkill && this.currentSkill.value === 'multiModal'){
        this.multiText = this.dealBindinf() || ''
        this.$emit('loadCallBack', this.agentConfig)
        console.log("多模态默认提示词===", this.multiText)
      }
      else if (this.stepList[this.curStep].type === 'aiGenerate') {
        console.log("步骤切换==生成结果");
        this.pageLoading = false
        let sendMessage = this.dealBindinf()

        this.$emit('loadCallBack', this.agentConfig)
        console.log("处理后的sendMessage==", sendMessage)
        if (this.sessions.length === 0 && this.systemSwitch === 1) {
          const systemContent = this.getSystemMessage();
          console.log("systemContent==", systemContent);

          if (systemContent) {
            this.sessions.push({
              role: 'system',
              content: systemContent
            });
          }
        }        
        // 用户询问
        this.sessions.push({
          role: 'user',
          content: sendMessage
        })
        this.robotAnimate = true
        this.$nextTick(() => {
          this.checkScrollButtons();
          this.watchContentChanges();
          // 监听窗口大小变化
          window.addEventListener('resize', () => {
            requestAnimationFrame(() => {
              this.checkScrollButtons();
            });
          });
        });
        // 表单发起/详情页ai模板跳转
        if (this.channel === 'appAi') {
          console.log("表单发起/详情页ai模板跳转");
          this.$emit('submitCallBack', { sessions: this.sessions, showQuestion: this.otherData.showQuestion })
        }
        else {
          console.log("正常流程");
          this.startRobot = true
          this.startAi(sendMessage)
        }
      } else if (this.stepList[this.curStep].type === 'dataWrite') {
        this.toDataWrite()
      } else if (['dataGenerate', 'fileGenerate', 'contentGenerate'].includes(this.stepList[this.curStep].type) ) { 
        // 数据查询、文件查询
        this.toDataGenerate()
      }
    },
    toDataGenerate() {
      this.pageLoading = false
      const content = this.dealBindinf() || ''
      this.defaultQuestion = this.filterHtmlTags(content);
    },
    dealBindinf () {
      let sendMessage = this.getText(this.bindinf)
      sendMessage = this.cleanHtmlStyle(sendMessage)
      // 如果存在传参，处理参数替换
      const paramsList = this.customDeskInfo && this.customDeskInfo.paramsList ? JSON.parse(this.customDeskInfo.paramsList) : []
      const searchList =  this.customDeskInfo && this.customDeskInfo.search ? this.dealQueryStr(this.customDeskInfo.search) : {}
      const storageKeys = ['dataAnalysisStorage', 'fileAnalysisStorage'];
      // 如果存在解析数据的值，则替换
      paramsList.forEach(item => {
        if(item.value === 'dataAnalysisStorage') {
          const localValue = localStorage.getItem('dataAnalysisStorage');
          if (localValue !== null) {
            item.value = localValue;
          }
        }
        else if(item.value === 'fileAnalysisStorage') {
          const localValue = localStorage.getItem('fileAnalysisStorage');
          if (localValue !== null) {
            item.value = localValue;
          }
        }
      });
      for (const key in searchList) {
        if (storageKeys.includes(searchList[key])) {
          const localValue = localStorage.getItem(searchList[key]);
          if (localValue !== null) {
            searchList[key] = localValue; // 替换对象的值
          }
        }
      }
      console.log("paramsList==",paramsList,searchList);
      
      if(this.knowledgeOpen){
        // 使用正则表达式匹配所有 ${xxx_aiGenerate} 模式
        const regex = /\${([^}]+)_aiGenerate}/g;
        
        // 替换所有匹配项
        sendMessage = sendMessage.replace(regex, (match, name) => {
          // 在 paramsList 中查找匹配的参数
          const param = paramsList.find(p => p.name === name);
          // 如果找到匹配的参数，返回其值，否则保持原样
          return param ? param.value : match;
        });
      }
      return sendMessage
    },
    async toDataWrite () {
      this.pageLoading = false
      this.showProgress = true
      const item = this.stepList[this.curStep]
      const content = this.dealBindinf() || ''
      const query = { 
        path: this.$url,
        aiModelId: this.aiModelId,
        dataWriteInfo: item.dataWriteInfo,
        customDataList: this.paramsListType2,
        content: content
      }
      const { code } = await aiparsecontent(query)
      this.showProgress = false
      const tip = code === 0 ? '分析成功，结果已生成。' : '分析失败，请重试。'
      this.$alert(tip, '提示', {
        confirmButtonText: '确定',
        callback: () => {
          this.closePop()
        },
      });
    },
    // 插入预设参数
    getSystemMessage() {
      const _html = dealText({
      text: this.paramConfig.bindinf,
      commonData: this.$store.state.userData,
      customData: this.customData,
      functionParms: this.functionParms,
      });
      
      // 过滤预设参数中的HTML标签
      const filteredBindinf = this.filterHtmlTags(_html);
      console.log("filteredBindinf==", filteredBindinf);
      return filteredBindinf;
    },
    //模板数据解析
    templateFun (e) {
      if (e.property) {
        console.log("解析模板",e);
        let ruleList = JSON.parse(e.property);
        let formdata = momVal(JSON.parse(e.property))
        let OthersFormdata = setOthersFormdata(ruleList, formdata);
        this.associationVisible = OthersFormdata.associationVisible;
        formdata = OthersFormdata.formdata;
        this.ruleList = OthersFormdata.template;
        this.othersObj = OthersFormdata.othersObj;
        // 明细数据兼容小程序bug
        for(let key in formdata) {
          if (key.search('details')!== -1) {
            formdata[key].forEach(item=>{
              for(let _key in item) {
                if (_key.search('relation-user')!== -1 || _key.search('radio')!== -1) {
                  if (item[_key]) {
                    item[_key] = item[_key].value ? item[_key].value : item[_key]
                  } 
                  try {
                    if (_key.search('relation-user')!== -1) {
                      item[_key] = typeof item[_key] == 'string' ? JSON.parse(item[_key]) : item[_key]
                    }
                  }catch(e){
                    console.log('解析错误', e)
                  }
                } 
              }
            })
          }
        }
        const defaultKey = {}
        if (Array.isArray(this.AuditList) && this.AuditList[0]) {
          const defaultKeyList = ['申请人_relation-user', '单号_text', '状态_status', '提交时间_date', '归档状态_status']
          defaultKeyList.forEach(item => {
            defaultKey[item] = this.handleDefaultKey(item, this.AuditList[0])
          })
        }
        this.formdata = {...formdata, ...defaultKey}
      }
    },
    openAppDialog (val) {
      this.$set(this, 'dialogInfo', val)
    },
    openAppInitiate ({approvalId, name, search, iId, id, datatype, popUps}) {
      console.log("asdsdd");
      
      this.openInput = {
        isVisible: true,
        approvalId: approvalId,
        name: name,
        search: search,
        iId: iId,
        isDetail: iId === 15 || iId === 16 /*|| iId === 13 || iId === 14*/,
        id: id || '',
        datatype: datatype
      }
      const obj = {
        2: 'dialog',
        3: 'new',
        4: 'old',
        5: 'rightdia'
      }
      this.dialogInfo = {
        isVisible: true,
        dialogName: name,
        dialogWidth: popUps.w + 'px',
        dialogHeight: popUps.h + 'px',
        openType: obj[popUps.open],
        customSize: popUps.customSize,
        diaSize: popUps.diaSize,
      }
      this.openAddInputShow = true
    },
    customScene(val) {
      const { url, query, open, popUps } = val
      const obj = {
        2: 'dialog',
        3: 'new',
        4: 'old',
        5: 'rightdia'
      }
      this.dialogInfo = {
        isVisible: true,
        dialogName: query.name,
        dialogWidth: popUps.w + 'px',
        dialogHeight: popUps.h + 'px',
        openType: obj[open],
        dialogUrl: url,
        customSize: popUps.customSize,
        diaSize: popUps.diaSize,
      }
    },
    doorUp() {
      // TODO 刷新列表
      if (this.dataInfo && this.dataInfo.pageId) {
        this.handleListInfo(this.dataInfo.pageId, '', this.querys)
      }
    },
    doorUpCloe () {
      // 弹窗关闭直接把变量改回之前的
      if (this.$store.state.doorCustomDataObj[this.customDeskId]) {
        const customData = this.$store.state.doorCustomDataObj[this.customDeskId]
        this.$store.commit('changeCustomData', { key: 'door', value: customData });
      }
      this.openInput = {
          isVisible: false,
          approvalId: '',
          search: {},
          iId: ''
      },
      this.dialogInfo = {
        dialogName: '',
        isVisible: false,
        dialogWidth: '80%',
        dialogHeight: '85vh',
        openType: 'dialog',
        customSize: 65,
        dialogUrl: '',
        diaSize: '',
        childDialog: true
      }
    },
    //- 提交
    async submitForm () {
      const ruleLisTparam = this.$refs.widgetOneLayerRef.widgetOneLayerPullData(1)
      console.log("走到", ruleLisTparam)

      if (ruleLisTparam.isCheck == 2) {
        return false;
      }
      let submitData = ruleLisTparam.dataList;
      console.log("submitData==",submitData);
      // 遍历 submitData 处理文件
      for (const [key, value] of Object.entries(submitData)) {
        if (key.includes('file') && Array.isArray(value) && value.length > 0) {
          // 遍历文件数组
          for (let i = 0; i < value.length; i++) {
            const file = value[i];
            if (file.response) {
              const fileName = file.response.replace(/^\/userfiles\//, '');
              // 检查是否已经存在 file.text，如果不存在才调用接口
              if (!file.text) {
                try {
                  const fileContent = await this.getfileCont(fileName);
                  // 只有当 fileContent 不是 false 时才存储
                  if (fileContent !== false) {
                    file.text = fileContent;
                  }
                } catch (error) {
                  console.error("获取文件内容失败:", error);
                }
              }
            }
          }
        }
      }
      this.stepList[this.curStep].formdata = submitData;
      this.curStep += 1
      this.stepChange()
    },
    // 获取文件解析内容
    async getfileCont(file) {
        const resFile = await getfilecontent({
            path: file,
            isocr: this.otherSet.ocrCheck || 0
        })
        if (resFile.code === 0) {
            return resFile.data
        }
        else{
            this.$message.error(resFile.msg)
            return false
        }
    },
    // 优化的流处理方法
    async handleStreamResponse(response) {
      const reader = response.body.getReader();
      // let accumulatedData = '';
      const FORCE_ENABLE_FEATURE = true;
      let lastFinishReason = null;
      let streamDone = false; // 标记流数据是否读取完成
      this.showContinueBtn = false; // 是否显示继续生成按钮

      // 检查并显示“继续生成”按钮的函数
      const checkshowContinue = () => {
        if (!this.showContinueBtn && streamDone && lastFinishReason === 'length' && !this.isRendering && this.renderBuffer.length === 0) {
          this.showContinueBtn = true;
          console.log("this.sessions==",this.sessions);
        }
      };
      const processChunk = () => {
        if (this.renderBuffer.length === 0) {
          this.isRendering = false;
          // 更新HTML代码块状态（从loading变为completed）
          if (streamDone) {
            this.updateHtmlCodeBlocksStatus();
          }
          // 检查是否满足所有条件：流数据完成 + finish_reason === 'length' + 渲染完成
          checkshowContinue();
          return;
        }
        
        const chunk = this.renderBuffer.shift();
        if (!this.sessions.length || this.sessions[this.sessions.length - 1].role !== 'assistant') {
          this.sessions.push({
            role: 'assistant',
            content: chunk,
            id: Date.now(),
            time: 0,
            thinking: true
          });
        } else {
          const lastSession = this.sessions[this.sessions.length - 1];
          lastSession.content += chunk;
          nextTick(() => {
            const wrap = document.querySelector('#chat-msg .el-scrollbar__wrap');
            if (wrap) {
              // 用户未手动干预时才自动跟随到底部
              if (!this.userHasScrolled) {
                wrap.scrollTop = wrap.scrollHeight;
              }
            }
          })
        }
        
        if (this.renderBuffer.length > 0) {
          requestAnimationFrame(processChunk);
        } else {
          this.isRendering = false;
          // 更新HTML代码块状态（从loading变为completed）
          if (streamDone) {
            this.updateHtmlCodeBlocksStatus();
          }
          // 检查是否满足所有条件：流数据完成 + finish_reason === 'length' + 渲染完成
          checkshowContinue();
        }
      };

      try {
        while (FORCE_ENABLE_FEATURE) {
          const { done, value } = await reader.read();
          this.addAppCheckResult()
          if (done) {
            streamDone = true; // 标记流数据读取完成
            break;
          }

          // 检查是否被中止
          if (this.abortController.signal.aborted) {
            reader.cancel(); // 取消读取流
            streamDone = true; // 标记流数据读取完成
            break;
          }

          // 解码新的数据块
          const chunk = new TextDecoder().decode(value);
          const lines = chunk.split('\n');

          for (const rawLine of lines) {
            const line = rawLine.trim();
            if (!line) continue;
            if (line === 'data: [DONE]') {
              streamDone = true; // 标记流数据读取完成
              continue;
            }

            if (this.valueModel === 'doubao-text' && line.startsWith('event:')) {
              continue;
            }

            try {
                const cleanedLine = line.replace(/^data: /, '');
                const parsedData = JSON.parse(cleanedLine);
                // 带思考过程
                const isReasoningModel = this.valueModel === 'deepseek-reasoner' ||
                  this.valueModel === 'deepseek-v4-pro' ||
                  this.valueModel === 'deepseek-v4-flash' ||
                  this.valueModel === 'zixun' ||
                  this.valueModel === 'gemini-3.1-pro-preview';
                // 安全地获取 reasoning_content

                let reaContent = null;
                if (isReasoningModel &&
                  parsedData &&
                  parsedData.choices &&
                  parsedData.choices[0] &&
                  parsedData.choices[0].delta) {
                  reaContent = parsedData.choices[0].delta.reasoning_content || null;
                }

                // 安全地获取 content
                let content = null;
                if (this.valueModel === 'dx-deepseek671b' ||
                  this.valueModel === 'deepseek-reasoner' ||
                  this.valueModel === 'deepseek-chat' ||
                  this.valueModel === 'deepseek-v4-pro' ||
                  this.valueModel === 'deepseek-v4-flash' ||
                  this.valueModel === 'gpt-5.4' ||
                  this.valueModel === 'gpt-5.5' ||
                  this.valueModel === 'zixun' ||
                  this.valueModel === 'gemini-3.1-pro-preview') {
                  // 优先从 delta.content 获取，如果没有则从 text 获取
                  if (parsedData && parsedData.choices && parsedData.choices[0]) {
                    const choice = parsedData.choices[0];
                    if (choice.delta && choice.delta.content !== undefined) {
                        content = choice.delta.content;
                    } else if (choice.text !== undefined) {
                        content = choice.text;
                    } else if (choice.delta && choice.delta.text !== undefined) {
                        content = choice.delta.text;
                    }
                  }
                } else if (this.valueModel === 'claude-opus-4-7') {
                  // Claude SSE 格式处理
                  if (parsedData && parsedData.type === 'content_block_delta' && parsedData.delta && parsedData.delta.type === 'text_delta') {
                    content = parsedData.delta.text;
                  }
                } else if(this.valueModel === 'doubao-text'){
                  // 豆包返回格式: type, response, item 等
                  // 从response.output_item.added 或 reasoning_summary_text.delta 中提取内容
                  if (parsedData.type === 'response.created' && parsedData.response && parsedData.response.id) {
                    this.lastResponseId = parsedData.response.id
                  }
                  if (parsedData.type === 'response.reasoning_summary_text.delta' && parsedData.delta) {
                    content = parsedData.delta;
                  } else if (parsedData.type === 'response.content_block_delta' && parsedData.delta) {
                    content = parsedData.delta;
                  }
                } else {
                  // 其他模型从 message.content 获取
                  if (parsedData && parsedData.message && parsedData.message.content !== undefined) {
                    content = parsedData.message.content;
                  }
                }

                // 记录最后一次的 finish_reason（如果存在）
                if (parsedData && parsedData.choices && parsedData.choices[0] && Object.prototype.hasOwnProperty.call(parsedData.choices[0], 'finish_reason')) {
                const fr = parsedData.choices[0].finish_reason;
                  if (fr !== null && fr !== undefined) {
                    lastFinishReason = fr;
                  }
                  } else if (parsedData && parsedData.candidates && parsedData.candidates[0] && Object.prototype.hasOwnProperty.call(parsedData.candidates[0], 'finishReason')) {
                  const fr = parsedData.candidates[0].finishReason;
                  if (fr !== null && fr !== undefined) {
                    lastFinishReason = fr;
                  }
                }

                // 处理思考标签和计时
                if (content === '<think>' || (isReasoningModel && reaContent !== null && reaContent !== '' && (content === null || content === '') && this.timer === null)) {
                    content = '<div class="think">';
                    if (isReasoningModel) {
                      content = '<div class="think">' + reaContent
                    }
                    // 开始计时
                    this.startTime = Date.now();
                    this.timer = setInterval(() => {
                        if (this.sessions.length > 0) {
                            const lastSession = this.sessions[this.sessions.length - 1];
                            lastSession.time = Math.floor((Date.now() - this.startTime) / 1000);
                        }
                    }, 1000);
                } else if (isReasoningModel && reaContent !== null && reaContent !== '' && (content === null || content === '') && this.timer) {
                  content = reaContent
                } else if (content === '</think>' || (isReasoningModel && (reaContent === null || reaContent === '') && content !== null && content !== '' && this.timer)) {
                    if (isReasoningModel) {
                      content = '</div>' + content
                    }
                    else{
                      content = '</div>';
                    }
                    // 停止计时并记录最终时间
                    if (this.timer) {
                        clearInterval(this.timer);
                        this.timer = null;
                        if (this.sessions.length > 0) {
                            const lastSession = this.sessions[this.sessions.length - 1];
                            lastSession.time = Math.floor((Date.now() - this.startTime) / 1000);
                            lastSession.thinking = false;
                        }
                    }
                }

                if (content) {
                    // accumulatedData += content;
                    if(this.layout.dialogText && this.layout.dialogText !== ''){
                      this.toSaveText(content)
                    }
                    // 将内容分片添加到渲染缓冲区
                    this.renderBuffer.push(content);

                    if (!this.isRendering) {
                        this.isRendering = true;
                        requestAnimationFrame(processChunk);
                    }
                }
            } catch (e) {
                console.error('Error parsing JSON:', e);
            }
          }
        }
      } catch (error) {
        if (error.name === 'AbortError') {
          console.log('流读取被中止');
        } else {
          console.error('Stream reading error:', error);
        }
      } finally {
        // 清理状态
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
        setTimeout(() => {
          this.saveSessionHistory()
        }, 1000)
        this.addAppCheckResult()
        this.think('thinkout');
        this.abortController = null;
        this.answerOver = true;        
        // 渲染 Mermaid 图表
        this.renderMermaidCharts();       
        // 更新HTML代码块状态（从loading变为completed）
        if (streamDone) {
            this.updateHtmlCodeBlocksStatus();
        }
        // 如果流数据已完成且渲染缓冲区为空，检查是否需要显示“继续生成”按钮
        // 如果还有数据在渲染，会在 processChunk 中检查
        checkshowContinue();
        this.$nextTick(() => {
          console.log('✅ 内容已完整渲染到页面');
          this.showDrag = true;
          // 执行回调
          const lastSession = this.sessions[this.sessions.length - 1]
          if (lastSession) {
            this.addMsg(lastSession.content)
          }
        });
      }
    },
    // 继续生成
    continueAnswer() {
      const block = document.getElementById('chat-msg')
      if (this.thinking) {
        this.$message.warning('正在努力分析中，请勿重复提交')
        return
      }
      if (!this.sessions || this.sessions.length === 0) {
        this.$message.warning('没有可继续生成的内容')
        return
      }

      this.think('thinking')
      this.answerOver = false
      this.showContinueBtn = false // 隐藏继续生成按钮

      // 获取现有的 sessions，并在最后一个元素上添加 prefix: true
      let sessionsClone = cloneDeep(this.sessions)
      const lastIndex = sessionsClone.length - 1
      if (lastIndex >= 0 && sessionsClone[lastIndex]) {
        sessionsClone[lastIndex].prefix = true
      }

      // 删除所有对象的 time 和 thinking 字段,避免重复提交的时候deepseek-r1:14b接口报错
      sessionsClone.forEach(item => {
        delete item.time;
        delete item.thinking;
      });

      // 知识库去掉最后一个节点
      if (this.isKnowledge && this.knowledgeInfo.id) {
        sessionsClone.splice(sessionsClone.length - 1, 1)
      }

      if (this.valueModel === 'yiyan') {
        this.answerType(sessionsClone).then(res => {
          this.think('thinkout')
          this.answerOver = true
          const msg = res.data.result
          if (!this.startRobot) return;

          if (this.isKnowledge && this.knowledgeInfo.id) {
            const editIndex = this.sessions.length - 1            
            if (this.sessions[editIndex] && this.sessions[editIndex].content) {
              this.sessions[editIndex].content += msg
            }
          } else {
            // 继续在最后一个元素上追加内容
            const lastSession = this.sessions[this.sessions.length - 1]
            if (lastSession) {
              lastSession.content += msg
            }
          }
        })
      }
      else {
        console.log("继续生成-自训模型==", sessionsClone)
        // 创建新的 AbortController
        this.abortController = new AbortController();
        let obj = {
          model: 'llamawxs',
          messages: sessionsClone,
          stream: false
        }
        const config = {
          method: "POST",
          headers: {
            Authorization: "Bearer " + "token",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(obj),
          signal: this.abortController.signal // 添加 signal
        }
        let _url = 'https://wxs.topeti.com/api/chat'
        const user = window.localStorage.getItem('user')
        // 公共调用写法
        let accesstoken = ''
        if (user) {
          accesstoken = JSON.parse(user).accesstoken
        }
        const applyTopetiHeaders = () => {
          config.headers.accesstoken = accesstoken
          config.headers.originapi = this.$url
          delete config.headers.Authorization
        }
        const setupStreamModel = (model, url) => {
          obj.model = model
          obj.stream = true
          _url = url
          applyTopetiHeaders()
        }
        const setupGeminiStreamModel = (model, url) => {
          obj.model = model
          obj.stream = true
          obj.temperature = 0.1
          obj.top_p = 1.0
          _url = url
          applyTopetiHeaders()
        }
        switch (this.valueModel) {
          // 电信模型
          case 'dx-deepseek671b':
            obj.model = '/data/nvme0/models/DeepSeek-R1-AWQ'
            obj.stream = true
            _url = 'https://eduxm.topeti.com/v1/chat/completions'
            break
          // 本地部署deeepseek
          case 'deepseek':
          case 'yiwen':
            obj.model = 'deepseek-r1:14b'
            obj.stream = true
            break
          // 千问大模型
          case 'zixun': {
            setupStreamModel('qwen3.7-max', 'https://user.topeti.com/qwen/chat')
            break
          }
          // 官方满血deepseek
          case 'deepseek-reasoner':
          case 'deepseek-chat':
          case 'deepseek-v4-flash':
          case 'deepseek-v4-pro': {
            obj.model = this.valueModel
            obj.stream = true
            const lastUserMessage = sessionsClone.filter(item => item.role === 'assistant').pop()
            obj.prompt = lastUserMessage && lastUserMessage.content ? lastUserMessage.content : ''
            // v4 flash关闭思考过程
            if(this.valueModel === 'deepseek-v4-flash'){
              obj.extra_body = {"thinking": {"type":"disabled"}}
            }
            _url = 'https://user.topeti.com/deepseek/beta'
            applyTopetiHeaders()
            break
          }
          case 'gpt-5.4':
          case 'gpt-5.5': {
            obj.model = this.valueModel
            obj.stream = true
            const lastUserMessage = sessionsClone.filter(item => item.role === 'assistant').pop()
            obj.prompt = lastUserMessage && lastUserMessage.content ? lastUserMessage.content : ''
            _url = 'https://user.topeti.com/nicerouter/chat/v1/chat/completions'
            applyTopetiHeaders()
            break
          }
          case 'claude-opus-4-7': {
            setupStreamModel(this.valueModel, 'https://user.topeti.com/nicerouter/cc/v1/messages')
            break
          }
          case 'gemini-3.1-pro-preview': {
            setupGeminiStreamModel(this.valueModel, 'https://user.topeti.com/nicerouter/gmtext/v1/chat/completions')
            break
          }
          // 豆包文字
          case 'doubao-text': {
            const sessionCont = this.sessions[this.sessions.length - 1];
            obj.model = 'doubao-seed-2-0-pro-260215'
            obj.stream = true
            // 如果存在上一个响应ID，则用于多轮对话
            if (this.lastResponseId) {
                obj.previous_response_id = this.lastResponseId
            }
            obj.input = [
                {
                    "role": "user",
                    "content": [
                        {
                            "type": "input_text",
                            "text": sessionCont.content
                        }
                    ]
                }
            ]
            _url = 'https://user.topeti.com/doubao/api/v3/responses'
            applyTopetiHeaders()
            delete obj.messages
            break
          }
        }
        config.body = JSON.stringify(obj)
        fetch(_url, config)
          .then(response => {
            if (this.isKnowledge && this.knowledgeInfo.id) {
              const editIndex = this.sessions.length - 1
              if (this.sessions[editIndex] && this.sessions[editIndex].content) {
                // 继续生成时，内容会通过流处理追加
              }
            } else {
              // 继续生成时，确保最后一个元素存在且是 assistant 角色
              // 这样流处理会在最后一个元素上追加内容，而不是创建新元素
              const lastSession = this.sessions[this.sessions.length - 1]
              if (!lastSession || lastSession.role !== 'assistant') {
                this.sessions.push({
                  role: 'assistant',
                  content: '',
                  id: Date.now(),
                  time: 0,
                  thinking: true
                });
              } else {
                // 如果最后一个元素存在，确保它有 content 属性（即使是空字符串）
                if (lastSession.content === undefined) {
                  lastSession.content = ''
                }
              }
            }
            this.handleStreamResponse(response)
          })
          .catch(error => {
            if (error.name === 'AbortError') {
              console.log('请求被中止');
            } else {
              console.error('Fetch error:', error);
            }
            this.think('thinkout');
            this.answerOver = true;
          });
      }
      this.$nextTick(function () {
        if (block && block.scrollHeight) block.scrollTop = block.scrollHeight
      })
    },
    checkDevicePixelRatio() {
      this.isScaled = window.devicePixelRatio <= 0.95
    },
    handleZoomChange() {
      setTimeout(this.checkDevicePixelRatio, 100)
    }
  },
  mounted() {
    setupMarkdownExtension();
    this.bindHtmlCodeButtons();
    this.isInquire()
    this.checkDevicePixelRatio()
    window.addEventListener('resize', this.handleZoomChange)
    this.$nextTick(() => { this.adjustTextareaHeight() })
  },
  updated() {
    this.$nextTick(() => {
      this.bindHtmlCodeButtons();
    });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleZoomChange)
  },
}
</script>

<style lang="scss" scoped>
.chat-wrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .btn-close-pop {
    display: none;
  }
  .ai-temp1 {
    display: none;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 32.666%;
    text-align: center;
    &.scaled {
      transform: scale(0.8);
      transform-origin: center bottom;
    }
    h6 {
      font-weight: normal;
      font-size: 40px;
      color: #6370FD;
      line-height: 60px;
      padding-bottom: 30px;
    }
    .pop {
      position: relative;
      width: 73.46%;
      margin: 0 auto -40px;
      img {
        display: block;
        width: 100%;
      }
      p {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        padding: 20px 20px 70px;
        font-size: 24px;
        line-height: 36px;
        color: #6370FD;
        text-align: left;
        box-sizing: border-box;
      }
    }
    .girl {
      display: block;
      width: 100%;
    }
  }
  .ai-temp2 {
    display: none;
    position: relative;
    background: url('https://bigdata.topeti.com/PCRepository/mainPlatform/pop-chat1.jpg') no-repeat 50% 100%;
    background-size: 100%;
    .girl {
      margin-left: 20px;
      width: 109px;
    }
    p {
      font-size: 20px;
      color: #6370FD;
      height: 30px;
      line-height: 30px;
      margin-top: 30px;
    }
    .step {
      margin: 32px 50px 0 0;
    }
  }
  .ai-temp3 {
    position: relative;
    display: none;
    height: 64px;
    background: url('https://bigdata.topeti.com/PCRepository/mainPlatform/pop-chat1.jpg') no-repeat 50% 100%;
    background-size: 100% 100%;
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
    img {
      display: block;
      width: 100%;
    }
    .girl {
      position: absolute;
      left: 20px;
      bottom: 0;
      width: 90px;
    }
    p {
      position: absolute;
      left: 120px;
      top: 50%;
      margin-top: -15px;
      font-size: 20px;
      color: #6370FD;
      height: 30px;
      line-height: 30px;
    }
    .step {
      float: right;
      margin: 10px 100px 0 0;
    }
  }
  .chat-main {
      width: 100%;
      display: flex;
      position: relative;
      .chat-content {
        flex: 1;
      }
  }
  .chat-content {
    height: 100%;
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 0 30px;
      h4 {
        display: none;
        height: 38px;
        color: #717376;
        font-weight: normal;
        font-size: 18px;
        line-height: 38px;
      }
    }
  }
  .cont {
    height: calc(100% - 40px);
    .data-generate {
      width: 100%;
      height: 100%;
      .chat-wrap {
        background-color: transparent;
      }
    }
    .inputBoxArea,
    .table-wrap {
      height: calc(100% - 75px);
      background: white;
      border-radius: 8px;
      :deep(.el-scrollbar__view), .form-class {
        min-height: 100%;
        .widget-one-layer {
          width: 90%;
          padding-right: 5%;
          padding-left: 5%;
        }
      }
    }
    .robot-wrap {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: calc(100% - 75px);
      background: #fff;
      position: relative;
      border-radius: 8px;
      border: 1px solid rgba(73, 85, 245, 0.2);
      .robot-start {
        width: 400px;
        text-align: center;
        img {
          display: block;
          width: 160px;
          margin: 0 auto 10px;
        }
        p {
          font-size: 16px;
          color: #999;
          line-height: 24px;
        }
      }
      .robot-result {
        position: relative;
        width: 100%;
        height: 100%;
        flex: 1;
        padding: 20px 0;
        box-sizing: border-box;
        overflow-x: hidden;
        .scroll-btn {
          div {
            position: absolute;
            right: 20px;
            z-index: 10;
            width: 32px;
            height: 32px;
            line-height: 35px;
            text-align: center;
            background-color: #FFFFFF;
            border: 2px solid #EDEDED;
            cursor: pointer;
            border-radius: 50%;
            transition: all 0.3s ease;
            i {
              font-size: 18px;
              color: #262626;
            }
            &:hover {
                border-color: #4E86FF;
              i {
                  color: #4E86FF;
              }
            }
          }

          .btn-up {
              top: 20px;
          }

          .btn-down {
              bottom: 20px;
          }
        }
        .app-check-list {
          display: flex;
          padding: 20px 0px;
          margin-bottom: 20px;
          border-bottom: 1px solid #E7EAF0;
          width: 100%;
          box-sizing: border-box;
          flex-wrap: wrap;
          .app-check-tips {
            font-size: 12px;
            color: #999;
            width: 100%;
            margin-bottom: 12px
          }
        }
        .user {
          display: flex;
          grid-template-rows: 17px 25px 1fr;
          gap: 0px;
          padding: 0 56px 16px 0;
          justify-content: right;
          position: relative;
          .avatar {
            position: absolute;
            right: 10px;
            top: 0;
            width: 34px;
            height: 34px;
            border-radius: 50%;
            border: 1px solid #09E2F7;
          }
          .msg {
            grid-area: 2 / 1 / 4 / 2;
            display: inline-block;
            color: #333;
            background-color: #DAE3FF;
            padding: 10px;
            border-radius: 12px;
            max-width: 70%;
            white-space: pre-line;
            transform: translateZ(0);
            will-change: contents;
            // 如果需要平滑过渡效果
            transition: opacity 0.1s ease-out;
            think {
              display: none;
            }
          }
        }
        .robot {
          margin: 0 30px;
          display: grid;
          grid-template-columns: 50px 1fr;
          grid-template-rows: 0 25px 1fr;
          grid-column-gap: 0px;
          grid-row-gap: 0px;
          .avatar {
            grid-area: 1 / 1 / 3 / 2;
            width: 34px;
            height: 34px;
            border-radius: 50%;
            border: 1px solid #09E2F7;
            margin: 3px 8px 0 0;
          }
          .box {
            grid-area: 2 / 2 / 4 / 3;
            .ai-think {
              margin-top: 5px;
              display: inline-block;
              font-size: 12px;
              color: #262626;
              padding: 10px;
              border-radius: 10px;
              background-color: #F5F5F5;
              cursor: pointer;

              i {
                  font-size: 12px;
                  color: #262626;
                  transition: transform 0.3s;
              }

              .WSicon-icon_interests {
                  margin-right: 5px;
              }

              .icon-xiala {
                  margin-left: 5px;
                  display: inline-block;
                  transform: rotate(180deg);
              }

              &:hover {
                  background: #eee;
              }
            }

            .ai-loading {
              margin: 10px 0;
              width: 24px;
              height: 24px;
              border: 2px solid #E7EAF0;
              border-top: 2px solid #4E86FF;
              border-radius: 50%;
              animation: ai-loading-spin 1s linear infinite;
            }

            @keyframes ai-loading-spin {
              0% {
                transform: rotate(0deg);
              }

              100% {
                transform: rotate(360deg);
              }
            }
            .ai-dots-loading {
                display: flex;
                align-items: center;
                gap: 5px;
                padding: 20px 10px;

                span {
                    display: inline-block;
                    width: 7px;
                    height: 7px;
                    border-radius: 50%;
                    background-color: #908EA3;
                    animation: ai-dot-bounce 1.2s infinite ease-in-out;

                    &:nth-child(1) { animation-delay: 0s; }
                    &:nth-child(2) { animation-delay: 0.2s; }
                    &:nth-child(3) { animation-delay: 0.4s; }
                }
            }

            @keyframes ai-dot-bounce {
                0%, 80%, 100% {
                    transform: scale(0.6);
                    opacity: 0.4;
                }
                40% {
                    transform: scale(1);
                    opacity: 1;
                }
            }

            .hide {
              .icon-xiala {
                transform: rotate(0);
              }
            }

            .msg {
              background-color: white;
              padding: 12px 14px;
              border-radius: 0 8px 8px 8px;
              max-width: 70%;
              white-space: pre-line;
              margin: 8px 0;
              border: 2px solid #DEDFDF;
              transform: translateZ(0);
              will-change: contents;
              
              // 如果需要平滑过渡效果
              transition: opacity 0.1s ease-out;
              think {
                display: none;
              }
            }
            .copy {
              cursor: pointer;
              height: 14px;
              line-height: 14px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
              img {
                float: left;
                margin-right: 4px;
              }
            }
          }
        }
      }
      .sendinput{
        width: 100%;
        margin-top: 20px;
        box-sizing: border-box;
        padding: 14px 14px 0;
        position: relative;
        border-radius: 8px;
        .input-area {
          max-width: 800px;
          margin: 0 auto;
          border-radius: 24px;
          background-color: #fff;
          border: 1px solid #E7EAF0;
          padding: 12px;
          box-sizing: border-box;
          transition: all 0.3s;

          &.input-border {
            border-color: #4475EB;
            background-color: #fff;
          }

          textarea {
            width: 100%;
            min-height: 48px;
            height: 48px;
            max-height: 190px;
            overflow-y: hidden;
            resize: none;
            display: block;
            outline: none;
            font-family: 'Microsoft YaHei', 'SimSun', 'Arial', sans-serif;
            font-size: 14px;
            line-height: 24px;
            color: #000;
            background: transparent;
            border: none;
            box-sizing: border-box;

            &:empty:before {
              content: attr(data-placeholder);
              color: #999;
            }

            &:focus {
              outline: none;
            }
          }

          .input-tools {
            margin-top: 10px;
            display: flex;
            gap: 15px;
            color: #666;
            font-size: 14px;
            justify-content: space-between;
            align-items: center;

            :deep(.el-select) {
              width: 120px;
              margin-right: 4px;

              .el-input__prefix {
                display: flex;
                align-items: center;
                padding-left: 6px;

                i {
                  font-size: 14px;
                  color: #666;
                }
              }

              .el-input__inner {
                padding-left: 26px;
              }
              .el-select__wrapper {
                  font-size: 14px;
                  min-height: 24px;
                  border-radius: 3px;
                  box-shadow: 0 0 0 1px #E7EAF0;
              }

              .el-select__selected-item {
                  color: #908EA3;
              }
            }

            .fl {
              display: flex;
              align-items: center;
            }

            .tool-item {
                display: inline-block;
                cursor: pointer;
                height: 24px;
                line-height: 24px;
                font-size: 14px;
                color: #908EA3;
                padding: 0 10px;
                margin-right: 4px;
                border-radius: 3px;
                background-color: #fff;
                border: 1px solid #E7EAF0;
                overflow: hidden;
                &:hover {
                    color: #3B82F6;
                }
                &.active {
                    color: #3B82F6;
                    border: 1px solid #3B82F6;
                }
            }

            .fr {
                display: flex;
                align-items: center;
                flex-shrink: 0;

                .btn-file,
                .btn-submit {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    width: 40px;
                    height: 40px;
                    margin-left: 5px;
                    border-radius: 50%;
                    flex-shrink: 0;

                    i {
                        font-size: 26px;
                    }

                    .WSicon-a-Rectangle346240893 {
                        font-size: 18px;
                    }
                }

                .btn-file {
                    i {
                        color: #4c4c4c;
                    }
                }

                .btn-submit {
                    background-color: #D6DEE8;
                    cursor: not-allowed;

                    i {
                        color: #fff;
                    }

                    &.btn-submit-high {
                        background-color: #4E86FF;
                        cursor: pointer;

                        &:hover {
                            background-color: #66b1ff;
                        }
                    }
                }
            }
          }
      }
      .sendinput-float {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: 10;
        background: #fff;
        margin-top: 0;
        border-radius: 0 0 8px 8px;
      }
      }
      .robot-default {
        .block {          
          padding-bottom: 20px;
          .user {
            margin: 0 24px;
            padding: 12px 0;
            border-bottom: 1px solid #d8d8d8;
            .avatar {
              display: none;
            }
            .msg {
              display: block;
              font-weight: bold;
              font-size: 18px;
              line-height: 25px;
              color: #000;
              background: transparent;
              width: 100%;
              max-width: 100%;
              padding: 0;
              margin: 0;
              transform: translateZ(0);
    will-change: contents;
    
    // 如果需要平滑过渡效果
    transition: opacity 0.1s ease-out;
              think {
                display: none;
              }
            }
          }
          .robot {
            display: block;
            margin: 0;
            .avatar {
              display: none;
            }
            .box {
              margin: 0 24px;
              .msg {
                display: block;
                width: 100%;
                max-width: 100%;
                padding: 0;
                border: none;
                transform: translateZ(0);
    will-change: contents;
    
    // 如果需要平滑过渡效果
    transition: opacity 0.1s ease-out;
                think {
                  display: none;
                }
              }
            }
          }
        }
        .robot {
          margin: 0;
          .avatar {
            display: none;
          }
          .box {
            margin: 0 24px;
            .msg {
              display: block;
              width: 100%;
              max-width: 100%;
              padding: 0;
              border: none;
              transform: translateZ(0);
    will-change: contents;
    
    // 如果需要平滑过渡效果
    transition: opacity 0.1s ease-out;
              think {
                display: none;
              }
            }
          }
        }      
      }
    }    
    .submit {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 10px;
      :deep(.el-button) {
        color: #fff;
        border-radius: 27px;
        background: linear-gradient(46.68deg, rgba(37, 170, 246, 1) 0%, rgba(39, 145, 245, 1) 24.94%, rgba(111, 105, 255, 1) 77.88%, rgba(166, 107, 255, 1) 100%);
      }
      :deep(.btn-stop) {
        color: #5086FF;
        border-color: #fff;
        .iconfont {
          color: #fff;
          margin-right: 10px;
        }
      }
    }
    .drag-area {
      position: relative;
      width: 100%;
      height: 28px;
      padding: 0 30px;
      overflow: hidden;
      box-sizing: border-box;
      .tools-container {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        height: 28px;
        line-height: 28px;
        box-sizing: border-box;
        &:hover {
          .tool {
            display: block;
          }
        }
        :deep(.el-link) {
          color: #666;
          margin: 0 10px;;
          i {
            margin-right: 5px;
          }
          &:hover {
            color: #4E86FF;
          }
        }
        .drag-left-content {
          display: flex;
          height: 30px;
        }
        .drag-right-content {
          display: flex;
          height: 30px;
          justify-content: flex-end;
        }        
      }
    }
  }  
}
.chat-wrap-history {
  .chat-content {
    flex: 1;
  }
}
.chat-oldui{
  background: #f5f5f5 url('https://bigdata.topeti.com/PCRepository/mainPlatform/bg-chat.png') no-repeat;
  background-size: 100% 100%;
  .chat-main {
    height: 100%;
  }
  .chat-content {
    max-width: 1200px;
    position: relative;
    margin: 0 auto;
    .header {
      padding: 20px 0;
      h4 {
        display: block;
      }
    }
  }
  .cont {
    height: calc(100% - 80px);
  }
}
.chat-newui{
  position: relative;
  .btn-close-pop {
    display: block;
    position: absolute;
    right: 30px;
    top: 22px;
    color: #0049FF;
    z-index: 10;
    cursor: pointer;
    .iconfont {
      font-size:20px;
    }
  }
  .chat-main {
    height: 80%;
  }
  .chat-content {
    position: absolute;
    right: 5.333%;
    top: 10%;
    z-index: 3;
    width: 60%;
    padding: 50px;
    box-sizing: border-box;
    border-radius: 25px;
    background: linear-gradient(180deg, rgba(244, 242, 253, 1) 0%, rgba(253, 252, 253, 1) 100%);
    box-shadow: -4.08px 4.08px 16.3px 0px rgba(131, 144, 147, 0.05);
    .header {
      padding: 0 0 30px;
      h4 {
        display: none;
      }
    }
  }
  .cont {
    height: calc(100% - 40px);
  }
}
.chat-pop {
  overflow: visible;
  border-radius: 14px;
  .ai-temp1 {
    h6 {
      font-size: 30px;
    }
    .pop {
      p {
        padding: 10px 20px 50px;
        font-size: 20px;
        line-height: 30px;
      }
    }
  }
  .chat-main {
    height: calc(100% - 120px);
  }
}
.chat-temp1 {
  background: #E9ECFF url('https://bigdata.topeti.com/PCRepository/mainPlatform/bg-chat1.jpg') no-repeat 0 100%;
  background-size: 100% 100%;
  .ai-temp1 {
    display: block;
  }
}
.chat-temp2 {
  background: #fcfcfc;
  .ai-temp2 {
    display: flex;
    align-items: center;
    .girl {
      flex-shrink: 0;
    }
    p {
      flex-shrink: 0;
    }
    .step {
      margin-left: auto;
      flex-shrink: 0;
    }
  }
  .ai-temp3 {
    display: block;
  }
  .chat-main {
    height: calc(100% - 85px);
  }
  .chat-content {
    position: inherit;
    right: auto;
    top: auto;
    width: auto;
    max-width: 1300px;
    margin: 0 auto;
    background: transparent;
    box-shadow: none;
    padding: 0;
    overflow: hidden;
    .header {
      display: none;
    }
    .cont {
      height: 100%;
      .robot-wrap {
        height: 100%;
        background: transparent;
        border: none;
        flex: 1;
        width: 100%;
        overflow-y: auto;
      }
    }
  }
}
:deep(.button-reveal) {
  .btn-two {
    span,
    .iconfont {
      color: #5086FF !important;
    }
  }
}
// 优化滚动性能
#chat-msg {
  -webkit-overflow-scrolling: touch;
  transform: translateZ(0);
  backface-visibility: hidden;
}

// Add styles for markdown editor
.v-md-editor {
  background: transparent !important;
  border: none !important;
  
  :deep(.v-md-editor-preview) {
    padding: 0;
    background: transparent;
    .github-markdown-body {
      padding: 0;
      color: #06071F;

      // 添加 data-v-md-line 样式
      div[data-v-md-line] {
        padding: 8px 0;
        line-height: 1.6;

        // 如果是第一行，移除顶部padding
        &[data-v-md-line="1"] {
          margin-top: 10px;
          padding-top: 0;
          color: #8B8B8B;
          border-left: 2px solid #e5e5e5;
          padding-left: 9px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
  /* 将样式作用到 v-md-editor 的预览区域，避免 scoped 隔离 */
  .v-md-editor .v-md-editor-preview .github-markdown-body {
    .html-code-block-wrapper {
      position: relative;
      margin: 16px 0;
    }
  
    .html-code-block-wrapper pre {
      position: relative;
      padding-top: 50px !important;
      margin: 0 !important;
    }
  
    .html-code-loading {
      position: relative;
      padding: 10px 20px;
      border-radius: 14px;
      text-align: center;
      background: #fff;
      border: 1px solid #ccc;
      margin: 16px 0;
    }
  
    .html-code-loading-content {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
    }
  
    .html-code-loading-text {
      color: #373C53;
      font-size: 16px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 12px;
    }
  
    .html-code-loading-text img {
      width: 112px;
      height: auto;
      flex-shrink: 0;
    }
  
    .html-code-completed {
      position: relative;
      padding: 10px 20px;
      border-radius: 14px;
      text-align: center;
      background: #fff;
      border: 1px solid #ccc;
      margin: 16px 0;
    }
  
    .html-code-completed-content {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      .html-code-actions {
          padding-left: 20px;
      }
    }
  
    .html-code-completed-text {
      color: #373C53;
      font-size: 16px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 12px;
    }
  
    .html-code-completed-text img {
      width: 112px;
      height: auto;
      flex-shrink: 0;
    }
  
    .html-code-container {
      position: relative;
      margin: 16px 0;
    }
  
    .html-code-container .html-code-actions {
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 1;
      display: flex;
      gap: 6px;
    }
  
    .html-code-container pre {
      position: relative;
      padding-top: 50px !important;
      margin: 0 !important;
    }
  
    .html-code-toggle-icon {
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 18px;
      font-style: normal;
      color: #4E86FF;
      cursor: pointer;
      transition: all 0.2s;
      flex-shrink: 0;
    }
  
    .html-code-toggle-icon:hover {
      color: #66b1ff;
    }
  
    .html-code-actions {
      display: flex;
      gap: 6px;
    }
  
    .html-code-btn {
      width: 100px;
      height: 40px;
      padding: 0;
      background: #4e86ff;
      color: #fff;
      border: 1px solid #4e86ff;
      border-radius: 58px;
      cursor: pointer;
      font-size: 12px;
      font-style: normal;
      transition: all 0.2s;
      backdrop-filter: blur(4px);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
      i {
          font-style: normal !important;
      }
    }
    .html-btn-result {
      width: 72px;
      height: 28px;
      line-height: 28px;
    }
  
    .html-code-btn i {
      font-size: 14px;
      line-height: 1;
    }
  
    .html-code-btn:hover {
      opacity: 0.9;
    }
  
    /* Prism 高亮 IDE 风格 */
    pre code { background: transparent !important;}
  
    /* html/markup 统一配色 */
    pre code.language-html,
    pre code.language-markup,
    pre .token.tag { color: #e06c75 !important; }
    pre .token.attr-name { color: #d19a66 !important; }
    pre .token.attr-value,
    pre .token.string { color: #98c379 !important; }
    pre .token.comment { color: #5c6370 !important; font-style: italic; }
    pre .token.punctuation { color: #abb2bf !important; }
    pre .token.doctype { color: #c678dd !important; }
    pre .token.script { color: #e5c07b !important; }
  }
.mermaid-wrapper {
  margin: 20px 0;
  position: relative;
}

.mermaid-container {
  background: #f6f8fa;
  border-radius: 6px;
  padding: 20px;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e1e4e8;
  overflow: auto;
}

.mermaid-loading {
  color: #586069;
  font-size: 14px;
}

.mermaid-error {
  color: #d73a49;
  padding: 20px;
  text-align: center;
  font-size: 14px;
}

/* 暗色主题适配 */
@media (prefers-color-scheme: dark) {
  .mermaid-container {
    background: #161b22;
    border-color: #30363d;
  }
  
  .mermaid-loading {
    color: #8b949e;
  }
}
/* 图片生成块样式 */
.img-block {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 10px;
}
.img-wrap {
  position: relative;
  width: 480px;
  min-height: 200px;
  margin-top: 10px;
  overflow: hidden;
  background: #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.img-wrap img {
  width: 100%;
  display: block;
}
.img-loading-mask {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f2f5;
  border-radius: 8px;
}
.img-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #d0d7de;
  border-top-color: #409eff;
  border-radius: 50%;
  animation: img-spin 0.8s linear infinite;
}
@keyframes img-spin {
  to { transform: rotate(360deg); }
}
.img-actions {
  position: absolute;
  left: 50%;
  bottom: 10px;
  z-index: 3;
  width: 195px;
  height: 38px;
  line-height: 38px;
  margin-left: -98px;
  display: flex;
  gap: 10px;
  justify-content: center;
  color: #fff;
  border-radius: 10px;
  background-color: #B0B7BE;
}
.img-btn {
  display: inline-block;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.ai-dots-loading {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 10px 0;
  span {
    display: inline-block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: #908EA3;
    animation: ai-dot-bounce 1.2s infinite ease-in-out;
    &:nth-child(1) { animation-delay: 0s; }
    &:nth-child(2) { animation-delay: 0.2s; }
    &:nth-child(3) { animation-delay: 0.4s; }
  }
}
@keyframes ai-dot-bounce {
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.4;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>